
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  var parcelRequire = $parcel$global["parcelRequire34b5"];
var parcelRegister = parcelRequire.register;
parcelRegister("9RhoK", function(module, exports) {
$parcel$export(module.exports, "createPayloads", function () { return $72d68f2fee0a7403$export$51b606e6d67c2231; });
$parcel$export(module.exports, "createExperimentalMetricsPayload", function () { return $72d68f2fee0a7403$export$6410c9ddb2ab201; });
$parcel$export(module.exports, "createExtraSearchPageInteractionPayload", function () { return $72d68f2fee0a7403$export$84796f657a45566d; });

var $gnQ3X = parcelRequire("gnQ3X");

var $cn8ql = parcelRequire("cn8ql");

var $lFOXD = parcelRequire("lFOXD");

var $2qaZZ = parcelRequire("2qaZZ");

var $f53LC = parcelRequire("f53LC");

var $5Cxn4 = parcelRequire("5Cxn4");

var $6xVyM = parcelRequire("6xVyM");

var $krUDg = parcelRequire("krUDg");

var $ceERr = parcelRequire("ceERr");

var $cH3JV = parcelRequire("cH3JV");

var $jS0DY = parcelRequire("jS0DY");

var $as5v9 = parcelRequire("as5v9");

var $03EZb = parcelRequire("03EZb");

var $f3CCR = parcelRequire("f3CCR");

var $bUAr3 = parcelRequire("bUAr3");

var $bLOdU = parcelRequire("bLOdU");

var $4gtBF = parcelRequire("4gtBF");

var $8pUKJ = parcelRequire("8pUKJ");

var $a48Mt = parcelRequire("a48Mt");

var $kqXw0 = parcelRequire("kqXw0");

var $d39M6 = parcelRequire("d39M6");

var $8Tf4I = parcelRequire("8Tf4I");

var $87kDd = parcelRequire("87kDd");

var $1CoTB = parcelRequire("1CoTB");

var $fBGIz = parcelRequire("fBGIz");

var $hij2V = parcelRequire("hij2V");

var $1odpW = parcelRequire("1odpW");

var $eNXJU = parcelRequire("eNXJU");

var $lnabs = parcelRequire("lnabs");

var $8y3c7 = parcelRequire("8y3c7");

var $g5BNF = parcelRequire("g5BNF");

var $lf4za = parcelRequire("lf4za");

var $4CyF2 = parcelRequire("4CyF2");

var $jmxTP = parcelRequire("jmxTP");

var $dCpJh = parcelRequire("dCpJh");

var $wA1y2 = parcelRequire("wA1y2");

var $gzPfK = parcelRequire("gzPfK");

var $haRJq = parcelRequire("haRJq");

var $jdiim = parcelRequire("jdiim");

var $6m6U8 = parcelRequire("6m6U8");

var $ejpCV = parcelRequire("ejpCV");

var $38JQt = parcelRequire("38JQt");

var $c2FBh = parcelRequire("c2FBh");

var $lyJgN = parcelRequire("lyJgN");

var $cxxtC = parcelRequire("cxxtC");

var $lY5jW = parcelRequire("lY5jW");

var $1x79m = parcelRequire("1x79m");

var $lnbBQ = parcelRequire("lnbBQ");

var $g3io0 = parcelRequire("g3io0");

var $lINhO = parcelRequire("lINhO");
var $72d68f2fee0a7403$var$_excluded = [
    "labelStack"
];
function $72d68f2fee0a7403$var$_createForOfIteratorHelper(r, e) {
    var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (!t) {
        if (Array.isArray(r) || (t = $72d68f2fee0a7403$var$_unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) {
            t && (r = t);
            var _n = 0, F = function F() {};
            return {
                s: F,
                n: function n() {
                    return _n >= r.length ? {
                        done: !0
                    } : {
                        done: !1,
                        value: r[_n++]
                    };
                },
                e: function e(r) {
                    throw r;
                },
                f: F
            };
        }
        throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }
    var o, a = !0, u = !1;
    return {
        s: function s() {
            t = t.call(r);
        },
        n: function n() {
            var r = t.next();
            return a = r.done, r;
        },
        e: function e(r) {
            u = !0, o = r;
        },
        f: function f() {
            try {
                a || null == t.return || t.return();
            } finally{
                if (u) throw o;
            }
        }
    };
}
function $72d68f2fee0a7403$var$_unsupportedIterableToArray(r, a) {
    if (r) {
        if ("string" == typeof r) return $72d68f2fee0a7403$var$_arrayLikeToArray(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? $72d68f2fee0a7403$var$_arrayLikeToArray(r, a) : void 0;
    }
}
function $72d68f2fee0a7403$var$_arrayLikeToArray(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}
function $72d68f2fee0a7403$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $72d68f2fee0a7403$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $72d68f2fee0a7403$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $f53LC.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $72d68f2fee0a7403$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $72d68f2fee0a7403$var$MAX_PAYLOAD_SIZE = 230;
function $72d68f2fee0a7403$var$getUfoNameOverride(interaction) {
    var ufoName = interaction.ufoName, apdex = interaction.apdex;
    try {
        var ufoNameOverrides = (0, $03EZb.getUfoNameOverrides)();
        if (ufoNameOverrides != null) {
            var metricKey = apdex.length > 0 ? apdex[0].key : '';
            if (ufoNameOverrides[ufoName][metricKey]) return ufoNameOverrides[ufoName][metricKey];
        }
        return ufoName;
    } catch (_unused) {
        return ufoName;
    }
}
function $72d68f2fee0a7403$var$getEarliestLegacyStopTime(interaction, labelStack) {
    var earliestLegacyStopTime = null;
    interaction.apdex.forEach(function(a) {
        var _a$labelStack;
        if (!(a !== null && a !== void 0 && a.stopTime)) return;
        if (!(0, $hij2V.labelStackStartWith)((_a$labelStack = a.labelStack) !== null && _a$labelStack !== void 0 ? _a$labelStack : [], labelStack)) return;
        if (a.stopTime > interaction.start && (earliestLegacyStopTime !== null && earliestLegacyStopTime !== void 0 ? earliestLegacyStopTime : a.stopTime) >= a.stopTime) earliestLegacyStopTime = a.stopTime;
    });
    return earliestLegacyStopTime;
}
function $72d68f2fee0a7403$var$getBm3EndTimeOrFallbackValue(interaction) {
    var _getEarliestLegacySto;
    var labelStack = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
    var fallbackValue = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : interaction.end;
    if (interaction.type === 'press') return fallbackValue;
    return (_getEarliestLegacySto = $72d68f2fee0a7403$var$getEarliestLegacyStopTime(interaction, labelStack)) !== null && _getEarliestLegacySto !== void 0 ? _getEarliestLegacySto : fallbackValue;
}
function $72d68f2fee0a7403$var$getPageVisibilityUpToTTI(interaction) {
    var start = interaction.start;
    var bm3EndTimeOrInteractionEndTime = $72d68f2fee0a7403$var$getBm3EndTimeOrFallbackValue(interaction);
    return (0, $4gtBF.getPageVisibilityState)(start, bm3EndTimeOrInteractionEndTime);
}
function $72d68f2fee0a7403$var$getMoreAccuratePageVisibilityUpToTTI(interaction) {
    var old = $72d68f2fee0a7403$var$getPageVisibilityUpToTTI(interaction);
    var tti = $72d68f2fee0a7403$var$getEarliestLegacyStopTime(interaction, []);
    if (!tti) return old;
    var buffered = (0, $38JQt.getVisibilityStateFromPerformance)(tti);
    if (!buffered) return old;
    if (buffered !== old) return 'mixed';
    return old;
}
function $72d68f2fee0a7403$var$getResourceTimings(start, end) {
    var _resourceTiming$getRe;
    return (_resourceTiming$getRe = $d39M6.getResourceTimings(start, end)) !== null && _resourceTiming$getRe !== void 0 ? _resourceTiming$getRe : undefined;
}
function $72d68f2fee0a7403$var$getBundleEvalTimings(start) {
    return $jS0DY.getBundleEvalTimings(start);
}
function $72d68f2fee0a7403$var$getSSRPhaseSuccess(type) {
    return type === 'page_load' ? $1CoTB.getSSRPhaseSuccess() : undefined;
}
function $72d68f2fee0a7403$var$getSSRFeatureFlags(type) {
    return type === 'page_load' ? $1CoTB.getSSRFeatureFlags() : undefined;
}
function $72d68f2fee0a7403$var$getPPSMetrics(interaction) {
    var _interaction$apdex;
    var start = interaction.start, end = interaction.end;
    var config = (0, $03EZb.getConfig)();
    var interactionStatus = (0, $g5BNF.default)(interaction);
    var pageVisibilityUpToTTAI = (0, $jmxTP.default)(interaction);
    var tti = (_interaction$apdex = interaction.apdex) === null || _interaction$apdex === void 0 || (_interaction$apdex = _interaction$apdex[0]) === null || _interaction$apdex === void 0 ? void 0 : _interaction$apdex.stopTime;
    var ttai = interactionStatus.originalInteractionStatus === 'SUCCEEDED' && pageVisibilityUpToTTAI === 'visible' ? Math.round(end - start) : undefined;
    var PPSMetricsAtTTI = tti !== undefined ? (0, $ceERr.getLighthouseMetrics)({
        start: start,
        stop: tti
    }) : null;
    var PPSMetricsAtTTAI = ttai !== undefined ? (0, $ceERr.getLighthouseMetrics)({
        start: start,
        stop: interaction.end
    }) : null;
    if ((0, $krUDg.fg)('platform_ufo_remove_deprecated_config_fields')) {
        if (PPSMetricsAtTTAI !== null) return PPSMetricsAtTTAI;
    } else {
        if (config !== null && config !== void 0 && config.shouldCalculateLighthouseMetricsFromTTAI && PPSMetricsAtTTAI !== null) return PPSMetricsAtTTAI;
        if (PPSMetricsAtTTI !== null) return $72d68f2fee0a7403$var$_objectSpread($72d68f2fee0a7403$var$_objectSpread({}, PPSMetricsAtTTI), {}, {
            'metrics@ttai': PPSMetricsAtTTAI
        });
    }
    return {};
}
function $72d68f2fee0a7403$var$getSSRProperties(type) {
    var ssrPhases = $72d68f2fee0a7403$var$getSSRPhaseSuccess(type);
    return $72d68f2fee0a7403$var$_objectSpread($72d68f2fee0a7403$var$_objectSpread({
        'ssr:success': (ssrPhases === null || ssrPhases === void 0 ? void 0 : ssrPhases.done) != null ? ssrPhases.done : (0, $jdiim.default)(type),
        'ssr:featureFlags': $72d68f2fee0a7403$var$getSSRFeatureFlags(type)
    }, (ssrPhases === null || ssrPhases === void 0 ? void 0 : ssrPhases.earlyFlush) != null ? {
        'ssr:earlyflush:success': ssrPhases.earlyFlush
    } : null), (ssrPhases === null || ssrPhases === void 0 ? void 0 : ssrPhases.prefetch) != null ? {
        'ssr:prefetch:success': ssrPhases.prefetch
    } : null);
}
function $72d68f2fee0a7403$var$getAssetsMetrics(interaction, SSRDoneTime) {
    try {
        var config = (0, $03EZb.getConfig)();
        var type = interaction.type;
        var allowedTypes = [
            'page_load'
        ];
        var assetsConfig = config === null || config === void 0 ? void 0 : config.assetsConfig;
        if (!allowedTypes.includes(type) || !assetsConfig) // Skip if: type not allowed or assetsClassification isn't configured
        return {};
        var reporter = new (0, $cH3JV.CHRReporter)();
        var resourceTimings = (0, $8Tf4I.filterResourceTimings)(interaction.start, interaction.end);
        var assets = reporter.get(resourceTimings, assetsConfig, SSRDoneTime);
        if (assets) // Only add assets in case it exists
        return {
            'event:assets': assets
        };
        return {};
    } catch (_unused2) {
        // Skip CHR in case of error
        return {};
    }
}
function $72d68f2fee0a7403$var$getTracingContextData(interaction) {
    var trace = interaction.trace, start = interaction.start;
    var tracingContextData = {};
    if (trace) tracingContextData = {
        'ufo:tracingContext': {
            'X-B3-TraceId': trace.traceId,
            'X-B3-SpanId': trace.spanId,
            // eslint-disable-next-line compat/compat
            browserTimeOrigin: +(performance.timeOrigin + start).toFixed(2)
        }
    };
    return tracingContextData;
}
function $72d68f2fee0a7403$var$optimizeCustomData(interaction) {
    var customData = interaction.customData, cohortingCustomData = interaction.cohortingCustomData, legacyMetrics = interaction.legacyMetrics;
    var customDataMap = customData.reduce(function(result, _ref) {
        var _result$get$data, _result$get;
        var labelStack = _ref.labelStack, data = _ref.data;
        var label = (0, $hij2V.stringifyLabelStackFully)(labelStack);
        var value = (_result$get$data = (_result$get = result.get(label)) === null || _result$get === void 0 ? void 0 : _result$get.data) !== null && _result$get$data !== void 0 ? _result$get$data : {};
        result.set(label, {
            labelStack: (0, $hij2V.optimizeLabelStack)(labelStack, (0, $gzPfK.getReactUFOPayloadVersion)(interaction.type)),
            data: Object.assign(value, data)
        });
        return result;
    }, new Map());
    // Merge cohorting custom data into the same map
    if (cohortingCustomData && cohortingCustomData.size > 0) {
        var _interaction$labelSta, _customDataMap$get$da, _customDataMap$get, _interaction$labelSta2;
        var label = (0, $hij2V.stringifyLabelStackFully)((_interaction$labelSta = interaction.labelStack) !== null && _interaction$labelSta !== void 0 ? _interaction$labelSta : []);
        var value = (_customDataMap$get$da = (_customDataMap$get = customDataMap.get(label)) === null || _customDataMap$get === void 0 ? void 0 : _customDataMap$get.data) !== null && _customDataMap$get$da !== void 0 ? _customDataMap$get$da : {};
        customDataMap.set(label, {
            labelStack: (0, $hij2V.optimizeLabelStack)((_interaction$labelSta2 = interaction.labelStack) !== null && _interaction$labelSta2 !== void 0 ? _interaction$labelSta2 : [], (0, $gzPfK.getReactUFOPayloadVersion)(interaction.type)),
            data: Object.assign(value, Object.fromEntries(cohortingCustomData))
        });
    }
    if (legacyMetrics) {
        var legacyMetricsFiltered = legacyMetrics.filter(function(item) {
            return item.type === 'PAGE_LOAD';
        }).reduce(function(result, currentValue) {
            for(var _i = 0, _Object$entries = Object.entries(currentValue.custom || {}); _i < _Object$entries.length; _i++){
                var _result$get$data2, _result$get2;
                var _Object$entries$_i = (0, $2qaZZ.default)(_Object$entries[_i], 2), key = _Object$entries$_i[0], _value = _Object$entries$_i[1];
                var _label = (0, $hij2V.stringifyLabelStackFully)([]);
                var labelValue = (_result$get$data2 = (_result$get2 = result.get(_label)) === null || _result$get2 === void 0 ? void 0 : _result$get2.data) !== null && _result$get$data2 !== void 0 ? _result$get$data2 : {};
                result.set(_label, {
                    labelStack: (0, $hij2V.optimizeLabelStack)([], (0, $gzPfK.getReactUFOPayloadVersion)(interaction.type)),
                    data: Object.assign(labelValue, (0, $f53LC.default)({}, key, _value))
                });
            }
            return result;
        }, new Map());
        return [].concat((0, $lFOXD.default)(customDataMap.values()), (0, $lFOXD.default)(legacyMetricsFiltered.values()));
    }
    return (0, $lFOXD.default)(customDataMap.values());
}
function $72d68f2fee0a7403$var$optimizeRedirects(redirects, interactionStart) {
    var lastRedirectTime = interactionStart;
    var updatedRedirects = redirects.sort(function(a, b) {
        return a.time - b.time;
    }).reduce(function(result, redirect) {
        var fromInteractionName = redirect.fromInteractionName, time = redirect.time;
        if (lastRedirectTime >= interactionStart) result.push({
            labelStack: [
                {
                    n: fromInteractionName
                }
            ],
            startTime: Math.round(lastRedirectTime),
            endTime: Math.round(time)
        });
        lastRedirectTime = time;
        return result;
    }, []);
    return updatedRedirects;
}
function $72d68f2fee0a7403$var$objectToArray() {
    var obj = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    return Object.keys(obj).reduce(function(result, key) {
        result.push({
            label: key,
            data: obj[key]
        });
        return result;
    }, []);
}
function $72d68f2fee0a7403$var$getBM3SubmetricsTimings(submetrics) {
    if (!submetrics) return null;
    var submetricsTimings = submetrics.filter(function(item) {
        return typeof item.stop === 'number' && !!item.key && typeof item.start === 'number';
    }).map(function(item) {
        var childSubmetrics;
        var newKey = "include/".concat(item.key);
        if (item.submetrics) childSubmetrics = $72d68f2fee0a7403$var$getBM3SubmetricsTimings(item.submetrics);
        return $72d68f2fee0a7403$var$_objectSpread((0, $f53LC.default)({}, newKey, {
            endTime: item.stop - item.start,
            startTime: item.start
        }), childSubmetrics ? childSubmetrics : {});
    });
    return submetricsTimings;
}
function $72d68f2fee0a7403$var$getBm3TrackerTimings(interaction) {
    var interactionLegacyMetrics = interaction.legacyMetrics;
    if (!interactionLegacyMetrics) return {};
    var legacyMetrics = interactionLegacyMetrics.map(function(item) {
        var _item$config, _item$config2, _item$marks;
        return {
            key: item.key,
            startTime: item.start,
            stopTime: item.stop,
            type: (_item$config = item.config) === null || _item$config === void 0 ? void 0 : _item$config.type,
            reactUFOName: (_item$config2 = item.config) === null || _item$config2 === void 0 ? void 0 : _item$config2.reactUFOName,
            fmp: ((_item$marks = item.marks) === null || _item$marks === void 0 ? void 0 : _item$marks['fmp']) || item.stop,
            source: 'bm3',
            timings: (0, $bUAr3.getBm3Timings)(item.marks, item.config.timings),
            submetrics: $72d68f2fee0a7403$var$getBM3SubmetricsTimings(item.submetrics),
            pageVisibleState: item.pageVisibleState
        };
    }).filter(function(item) {
        return !!item.type;
    });
    return {
        legacyMetrics: legacyMetrics
    };
}
function $72d68f2fee0a7403$var$getStylesheetMetrics() {
    try {
        var doc = (0, $6xVyM.getDocument)();
        if (!doc) return {};
        var stylesheets = Array.from(doc.styleSheets);
        var stylesheetCount = stylesheets.length;
        var cssrules = Array.from(doc.styleSheets).reduce(function(acc, item) {
            // Other domain stylesheets throw a SecurityError
            try {
                return acc + item.cssRules.length;
            } catch (_unused3) {
                return acc;
            }
        }, 0);
        var styleElements = doc.querySelectorAll('style').length;
        var styleProps = doc.querySelectorAll('[style]');
        var styleDeclarations = Array.from(doc.querySelectorAll('[style]')).reduce(function(acc, item) {
            try {
                if ('style' in item) return acc + item.style.length;
                else return acc;
            } catch (_unused4) {
                return acc;
            }
        }, 0);
        return {
            'ufo:stylesheets': stylesheetCount,
            'ufo:styleElements': styleElements,
            'ufo:styleProps': styleProps.length,
            'ufo:styleDeclarations': styleDeclarations,
            'ufo:cssrules': cssrules
        };
    } catch (_unused5) {
        return {};
    }
}
var $72d68f2fee0a7403$var$regularTTAI;
var $72d68f2fee0a7403$var$expTTAI;
function $72d68f2fee0a7403$var$getErrorCounts(interaction) {
    return {
        'ufo:errors:globalCount': (0, $bLOdU.getGlobalErrorCount)(),
        'ufo:errors:count': interaction.errors.length
    };
}
function $72d68f2fee0a7403$var$createInteractionMetricsPayload(_x, _x2, _x3, _x4, _x5) {
    return $72d68f2fee0a7403$var$_createInteractionMetricsPayload.apply(this, arguments);
}
/**
 * The return type of createInteractionMetricsPayload.
 *
 * This is the GASv3 event envelope containing the interaction metrics payload
 * in `attributes.properties`. The properties object contains a mix of
 * well-known keys (event:*, metric:*, ufo:*, ssr:*, experience:*, interactionMetrics)
 * and dynamic keys from various helper functions.
 *
 * For a more detailed schema of the payload shape, see ReactUFOPayload in
 * `../common/react-ufo-payload-schema.ts`.
 */ function $72d68f2fee0a7403$var$_createInteractionMetricsPayload() {
    $72d68f2fee0a7403$var$_createInteractionMetricsPayload = (0, $cn8ql.default)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5Cxn4))).mark(function _callee(interaction, interactionId, experimental, criticalPayloadCount, vcMetrics) {
        var _config$enableBetterP, _window$location, _config$additionalPay;
        var interactionPayloadStart, config, end, start, ufoName, knownSegments, rate, type, abortReason, routeName, featureFlags, previousInteractionName, isPreviousInteractionAborted, abortedByInteractionName, responsiveness, unknownElementName, unknownElementHierarchy, hydration, pageVisibilityAtTTI, pageVisibilityAtTTAI, segments, segmentTree, isDetailedPayload, isPageLoadEvent, isPageLoad, calculatePageVisibilityFromTheStartOfPageLoad, moreAccuratePageVisibilityAtTTI, moreAccuratePageVisibilityAtTTAI, labelStack, getInitialPageLoadSSRMetrics, pageLoadInteractionMetrics, getDetailedInteractionMetrics, getPageLoadDetailedInteractionMetrics, newUFOName, resourceTimings, _yield$Promise$all, _yield$Promise$all2, finalVCMetrics, experimentalMetrics, paintMetrics, batteryInfo, getReactHydrationStats, payload, size, vcRev, rawData, rawDataSize, interactionMetricsFieldsToTrim, topLevelFieldsToTrim, properties, interactionMetrics, _iterator, _step, field, trimmedFields, _i2, _topLevelFieldsToTrim, _field, _trimmedFields, isVCRevisionTrimEnabled;
        return (0, (/*@__PURE__*/$parcel$interopDefault($5Cxn4))).wrap(function _callee$(_context) {
            while(true)switch(_context.prev = _context.next){
                case 0:
                    interactionPayloadStart = performance.now();
                    config = (0, $03EZb.getConfig)();
                    if (config) {
                        _context.next = 4;
                        break;
                    }
                    throw Error('UFO Configuration not provided');
                case 4:
                    end = interaction.end, start = interaction.start, ufoName = interaction.ufoName, knownSegments = interaction.knownSegments, rate = interaction.rate, type = interaction.type, abortReason = interaction.abortReason, routeName = interaction.routeName, featureFlags = interaction.featureFlags, previousInteractionName = interaction.previousInteractionName, isPreviousInteractionAborted = interaction.isPreviousInteractionAborted, abortedByInteractionName = interaction.abortedByInteractionName, responsiveness = interaction.responsiveness, unknownElementName = interaction.unknownElementName, unknownElementHierarchy = interaction.unknownElementHierarchy, hydration = interaction.hydration;
                    pageVisibilityAtTTI = $72d68f2fee0a7403$var$getPageVisibilityUpToTTI(interaction);
                    pageVisibilityAtTTAI = (0, $jmxTP.default)(interaction);
                    segments = !(0, $krUDg.fg)('platform_ufo_remove_deprecated_config_fields') && config.killswitchNestedSegments ? [] : knownSegments;
                    segmentTree = (0, $gzPfK.getReactUFOPayloadVersion)(interaction.type) === '2.0.0' ? (0, $hij2V.buildSegmentTree)(segments.map(function(segment) {
                        return segment.labelStack;
                    })) : {};
                    isDetailedPayload = pageVisibilityAtTTAI === 'visible';
                    isPageLoadEvent = type === 'page_load' || type === 'transition';
                    isPageLoad = type === 'page_load';
                    calculatePageVisibilityFromTheStartOfPageLoad = ((_config$enableBetterP = config.enableBetterPageVisibilityApi) !== null && _config$enableBetterP !== void 0 ? _config$enableBetterP : (0, $krUDg.fg)('platform_enable_better_page_visibility')) && isPageLoadEvent;
                    moreAccuratePageVisibilityAtTTI = calculatePageVisibilityFromTheStartOfPageLoad ? $72d68f2fee0a7403$var$getMoreAccuratePageVisibilityUpToTTI(interaction) : null;
                    moreAccuratePageVisibilityAtTTAI = calculatePageVisibilityFromTheStartOfPageLoad ? (0, $lf4za.getMoreAccuratePageVisibilityUpToTTAI)(interaction) : null;
                    labelStack = interaction.labelStack ? {
                        labelStack: (0, $hij2V.optimizeLabelStack)(interaction.labelStack, (0, $gzPfK.getReactUFOPayloadVersion)(interaction.type))
                    } : {}; // Page Load
                    getInitialPageLoadSSRMetrics = function getInitialPageLoadSSRMetrics() {
                        var _config$ssr;
                        if (!isPageLoad) return {};
                        var config = (0, $03EZb.getConfig)();
                        var SSRDoneTimeValue = (0, $haRJq.default)(config);
                        var SSRDoneTime = SSRDoneTimeValue !== undefined ? {
                            SSRDoneTime: Math.round(SSRDoneTimeValue)
                        } : {};
                        var isBM3ConfigSSRDoneAsFmp = interaction.metaData.__legacy__bm3ConfigSSRDoneAsFmp;
                        var isUFOConfigSSRDoneAsFmp = interaction.metaData.__legacy__bm3ConfigSSRDoneAsFmp || !!(config !== null && config !== void 0 && (_config$ssr = config.ssr) !== null && _config$ssr !== void 0 && _config$ssr.getSSRDoneTime);
                        if (!experimental && (isBM3ConfigSSRDoneAsFmp || isUFOConfigSSRDoneAsFmp) && SSRDoneTimeValue !== undefined) try {
                            performance.mark("FMP", {
                                startTime: SSRDoneTimeValue,
                                detail: {
                                    devtools: {
                                        dataType: 'marker'
                                    }
                                }
                            });
                        } catch (_unused6) {}
                        return $72d68f2fee0a7403$var$_objectSpread($72d68f2fee0a7403$var$_objectSpread({}, SSRDoneTime), {}, {
                            isBM3ConfigSSRDoneAsFmp: isBM3ConfigSSRDoneAsFmp,
                            isUFOConfigSSRDoneAsFmp: isUFOConfigSSRDoneAsFmp
                        });
                    };
                    pageLoadInteractionMetrics = getInitialPageLoadSSRMetrics(); // Detailed payload. Page visibility = visible
                    getDetailedInteractionMetrics = function getDetailedInteractionMetrics(resourceTimings) {
                        if (experimental || window.__UFO_COMPACT_PAYLOAD__ || !isDetailedPayload) return {};
                        var spans = [].concat((0, $lFOXD.default)(interaction.spans), (0, $lFOXD.default)((0, $a48Mt.interactionSpans)));
                        (0, $a48Mt.interactionSpans).length = 0;
                        var shouldInclude3pHolds = (0, $03EZb.shouldUseRawDataThirdPartyBehavior)(ufoName, type);
                        var basePayload = {
                            errors: interaction.errors.map(function(_ref2) {
                                var labelStack = _ref2.labelStack, others = (0, $gnQ3X.default)(_ref2, $72d68f2fee0a7403$var$_excluded);
                                return $72d68f2fee0a7403$var$_objectSpread($72d68f2fee0a7403$var$_objectSpread({}, others), {}, {
                                    labelStack: labelStack && (0, $hij2V.optimizeLabelStack)(labelStack, (0, $gzPfK.getReactUFOPayloadVersion)(interaction.type))
                                });
                            }),
                            holdActive: (0, $lFOXD.default)(interaction.holdActive.values()),
                            redirects: $72d68f2fee0a7403$var$optimizeRedirects(interaction.redirects, start),
                            holdInfo: (0, $cxxtC.optimizeHoldInfo)(experimental ? interaction.holdExpInfo : interaction.holdInfo, start, (0, $gzPfK.getReactUFOPayloadVersion)(interaction.type)),
                            spans: (0, $g3io0.optimizeSpans)(spans, start, (0, $gzPfK.getReactUFOPayloadVersion)(interaction.type)),
                            requestInfo: (0, $lnbBQ.optimizeRequestInfo)(interaction.requestInfo, start, (0, $gzPfK.getReactUFOPayloadVersion)(interaction.type)),
                            customTimings: (0, $lyJgN.optimizeCustomTimings)(interaction.customTimings, start),
                            bundleEvalTimings: $72d68f2fee0a7403$var$objectToArray($72d68f2fee0a7403$var$getBundleEvalTimings(start)),
                            resourceTimings: $72d68f2fee0a7403$var$objectToArray(resourceTimings)
                        };
                        // Include third-party holds when feature flag is active
                        if (shouldInclude3pHolds) {
                            var _interaction$hold3pIn;
                            return $72d68f2fee0a7403$var$_objectSpread($72d68f2fee0a7403$var$_objectSpread({}, basePayload), {}, {
                                hold3pActive: interaction.hold3pActive ? (0, $lFOXD.default)(interaction.hold3pActive.values()) : [],
                                hold3pInfo: (0, $cxxtC.optimizeHoldInfo)((_interaction$hold3pIn = interaction.hold3pInfo) !== null && _interaction$hold3pIn !== void 0 ? _interaction$hold3pIn : [], start, (0, $gzPfK.getReactUFOPayloadVersion)(interaction.type))
                            });
                        }
                        return basePayload;
                    }; // Page load & detailed payload
                    getPageLoadDetailedInteractionMetrics = function getPageLoadDetailedInteractionMetrics() {
                        var _config$ssr2, _config$ssr2$getSSRTi;
                        if (!isPageLoad || !isDetailedPayload) return {};
                        var initialPageLoadExtraTimings = $72d68f2fee0a7403$var$objectToArray($8pUKJ.getTimings());
                        var config = (0, $03EZb.getConfig)();
                        var defaultSSRTimings = $72d68f2fee0a7403$var$objectToArray($1CoTB.getSSRTimings());
                        var ssrTimingsFromConfig = config === null || config === void 0 || (_config$ssr2 = config.ssr) === null || _config$ssr2 === void 0 || (_config$ssr2$getSSRTi = _config$ssr2.getSSRTimings) === null || _config$ssr2$getSSRTi === void 0 ? void 0 : _config$ssr2$getSSRTi.call(_config$ssr2);
                        return {
                            initialPageLoadExtraTimings: initialPageLoadExtraTimings,
                            SSRTimings: ssrTimingsFromConfig ? [].concat((0, $lFOXD.default)(ssrTimingsFromConfig), (0, $lFOXD.default)(defaultSSRTimings)) : defaultSSRTimings
                        };
                    };
                    if (experimental) $72d68f2fee0a7403$var$expTTAI = (0, $6m6U8.default)(interaction);
                    else $72d68f2fee0a7403$var$regularTTAI = (0, $6m6U8.default)(interaction);
                    newUFOName = (0, $hij2V.sanitizeUfoName)(ufoName);
                    resourceTimings = $72d68f2fee0a7403$var$getResourceTimings(start, end);
                    _context.t0 = Promise;
                    _context.t1 = vcMetrics;
                    if (_context.t1) {
                        _context.next = 29;
                        break;
                    }
                    _context.next = 28;
                    return (0, $ejpCV.default)(interaction);
                case 28:
                    _context.t1 = _context.sent;
                case 29:
                    _context.t2 = _context.t1;
                    _context.t3 = experimental ? (0, $f3CCR.getExperimentalVCMetrics)(interaction) : Promise.resolve(undefined);
                    _context.t4 = (0, $dCpJh.getPaintMetricsToLegacyFormat)(type, end);
                    _context.t5 = (0, $lnabs.getBatteryInfoToLegacyFormat)();
                    _context.t6 = [
                        _context.t2,
                        _context.t3,
                        _context.t4,
                        _context.t5
                    ];
                    _context.next = 36;
                    return _context.t0.all.call(_context.t0, _context.t6);
                case 36:
                    _yield$Promise$all = _context.sent;
                    _yield$Promise$all2 = (0, $2qaZZ.default)(_yield$Promise$all, 4);
                    finalVCMetrics = _yield$Promise$all2[0];
                    experimentalMetrics = _yield$Promise$all2[1];
                    paintMetrics = _yield$Promise$all2[2];
                    batteryInfo = _yield$Promise$all2[3];
                    if (!experimental) (0, $eNXJU.addPerformanceMeasures)(interaction.start, (0, $lFOXD.default)((finalVCMetrics === null || finalVCMetrics === void 0 ? void 0 : finalVCMetrics['ufo:vc:rev']) || []));
                    getReactHydrationStats = function getReactHydrationStats() {
                        if (!hydration) return {};
                        return {
                            hydration: hydration
                        };
                    };
                    payload = {
                        actionSubject: 'experience',
                        action: 'measured',
                        eventType: 'operational',
                        source: 'measured',
                        tags: [
                            'observability'
                        ],
                        attributes: {
                            properties: $72d68f2fee0a7403$var$_objectSpread($72d68f2fee0a7403$var$_objectSpread($72d68f2fee0a7403$var$_objectSpread($72d68f2fee0a7403$var$_objectSpread($72d68f2fee0a7403$var$_objectSpread($72d68f2fee0a7403$var$_objectSpread($72d68f2fee0a7403$var$_objectSpread($72d68f2fee0a7403$var$_objectSpread($72d68f2fee0a7403$var$_objectSpread($72d68f2fee0a7403$var$_objectSpread($72d68f2fee0a7403$var$_objectSpread($72d68f2fee0a7403$var$_objectSpread($72d68f2fee0a7403$var$_objectSpread($72d68f2fee0a7403$var$_objectSpread($72d68f2fee0a7403$var$_objectSpread($72d68f2fee0a7403$var$_objectSpread($72d68f2fee0a7403$var$_objectSpread({
                                // basic
                                'event:hostname': ((_window$location = window.location) === null || _window$location === void 0 ? void 0 : _window$location.hostname) || 'unknown',
                                'event:product': config.product,
                                'event:population': config.population,
                                'event:schema': '1.0.0',
                                'event:sizeInKb': 0,
                                'event:source': {
                                    name: 'react-ufo/web',
                                    version: (0, $gzPfK.getReactUFOPayloadVersion)(interaction.type)
                                },
                                'event:region': config.region || 'unknown',
                                'experience:key': experimental ? 'custom.experimental-interaction-metrics' : 'custom.interaction-metrics',
                                'experience:name': newUFOName,
                                // Include CPU usage monitoring data
                                'event:cpu:usage': (0, $kqXw0.createPressureStateReport)(interaction.start, interaction.end),
                                'event:memory:usage': (0, $kqXw0.createMemoryStateReport)(interaction.start, interaction.end)
                            }, criticalPayloadCount !== undefined ? {
                                'ufo:multipayload': true,
                                'ufo:criticalPayloadCount': criticalPayloadCount
                            } : {}), {}, {
                                'ufo:pageVisibilityHiddenTimestamp': (0, $4gtBF.getEarliestHiddenTiming)(interaction.start, interaction.end),
                                'ufo:wasPageHiddenBeforeInit': (0, $4gtBF.getHasHiddenTimingBeforeSetup)(),
                                'ufo:isOpenedInBackground': (0, $4gtBF.isOpenedInBackground)(interaction.type),
                                'ufo:isTabThrottled': (0, $4gtBF.isTabThrottled)(start, end),
                                'ufo:pageVisibilityTimeline': (0, $4gtBF.getPageVisibilityTimeline)(start, end)
                            }, (0, $krUDg.fg)('ufo_detect_aborting_interaction_during_ssr') ? {
                                'ufo:hasAbortingInteractionDuringSSR': (0, $fBGIz.getHasAbortingEventDuringSSR)()
                            } : {}), (0, $8y3c7.getBrowserMetadataToLegacyFormat)()), batteryInfo), $72d68f2fee0a7403$var$getSSRProperties(type)), $72d68f2fee0a7403$var$getAssetsMetrics(interaction, pageLoadInteractionMetrics === null || pageLoadInteractionMetrics === void 0 ? void 0 : pageLoadInteractionMetrics.SSRDoneTime)), $72d68f2fee0a7403$var$getPPSMetrics(interaction)), paintMetrics), (0, $4CyF2.getNavigationMetricsToLegacyFormat)(type)), finalVCMetrics), experimentalMetrics), (_config$additionalPay = config.additionalPayloadData) === null || _config$additionalPay === void 0 ? void 0 : _config$additionalPay.call(config, interaction)), $72d68f2fee0a7403$var$getTracingContextData(interaction)), $72d68f2fee0a7403$var$getStylesheetMetrics()), $72d68f2fee0a7403$var$getErrorCounts(interaction)), getReactHydrationStats()), {}, {
                                interactionMetrics: $72d68f2fee0a7403$var$_objectSpread($72d68f2fee0a7403$var$_objectSpread($72d68f2fee0a7403$var$_objectSpread($72d68f2fee0a7403$var$_objectSpread($72d68f2fee0a7403$var$_objectSpread($72d68f2fee0a7403$var$_objectSpread($72d68f2fee0a7403$var$_objectSpread($72d68f2fee0a7403$var$_objectSpread($72d68f2fee0a7403$var$_objectSpread({
                                    namePrefix: config.namePrefix || '',
                                    segmentPrefix: config.segmentPrefix || '',
                                    interactionId: interactionId,
                                    pageVisibilityAtTTI: pageVisibilityAtTTI,
                                    pageVisibilityAtTTAI: pageVisibilityAtTTAI,
                                    experimental__pageVisibilityAtTTI: moreAccuratePageVisibilityAtTTI,
                                    experimental__pageVisibilityAtTTAI: moreAccuratePageVisibilityAtTTAI,
                                    // raw interaction metrics
                                    rate: rate,
                                    routeName: routeName,
                                    type: type,
                                    abortReason: abortReason,
                                    featureFlags: featureFlags,
                                    previousInteractionName: previousInteractionName,
                                    isPreviousInteractionAborted: isPreviousInteractionAborted,
                                    abortedByInteractionName: abortedByInteractionName,
                                    // performance
                                    apdex: (0, $c2FBh.optimizeApdex)(interaction.apdex, (0, $gzPfK.getReactUFOPayloadVersion)(interaction.type)),
                                    end: Math.round(end)
                                }, interaction.end3p ? {
                                    end3p: Math.round(interaction.end3p)
                                } : {}), {}, {
                                    start: Math.round(start),
                                    segments: (0, $gzPfK.getReactUFOPayloadVersion)(interaction.type) === '2.0.0' ? segmentTree : (0, $hij2V.getOldSegmentsLabelStack)(segments, interaction.type),
                                    marks: (0, $lY5jW.optimizeMarks)(interaction.marks, (0, $gzPfK.getReactUFOPayloadVersion)(interaction.type)),
                                    customData: $72d68f2fee0a7403$var$optimizeCustomData(interaction),
                                    reactProfilerTimings: (0, $1x79m.optimizeReactProfilerTimings)(interaction.reactProfilerTimings, start, (0, $gzPfK.getReactUFOPayloadVersion)(interaction.type)),
                                    minorInteractions: interaction.minorInteractions
                                }, responsiveness ? {
                                    responsiveness: responsiveness
                                } : {}), labelStack), pageLoadInteractionMetrics), getDetailedInteractionMetrics(resourceTimings)), getPageLoadDetailedInteractionMetrics()), $72d68f2fee0a7403$var$getBm3TrackerTimings(interaction)), {}, {
                                    'metric:ttai': experimental ? $72d68f2fee0a7403$var$regularTTAI || $72d68f2fee0a7403$var$expTTAI : undefined,
                                    'metric:experimental:ttai': $72d68f2fee0a7403$var$expTTAI
                                }, unknownElementName ? {
                                    unknownElementName: unknownElementName
                                } : {}), unknownElementHierarchy ? {
                                    unknownElementHierarchy: unknownElementHierarchy
                                } : {}),
                                'ufo:payloadTime': (0, $87kDd.roundEpsilon)(performance.now() - interactionPayloadStart)
                            })
                        }
                    };
                    if (experimental) {
                        $72d68f2fee0a7403$var$regularTTAI = undefined;
                        $72d68f2fee0a7403$var$expTTAI = undefined;
                    }
                    size = (0, $wA1y2.default)(payload.attributes.properties);
                    vcRev = payload.attributes.properties['ufo:vc:rev'];
                    if (Array.isArray(vcRev)) {
                        rawData = vcRev.find(function(item) {
                            return item.revision === 'raw-handler';
                        });
                        if (rawData) {
                            rawDataSize = (0, $wA1y2.default)(rawData);
                            payload.attributes.properties['ufo:vc:raw:size'] = rawDataSize;
                            if (size > $72d68f2fee0a7403$var$MAX_PAYLOAD_SIZE && vcRev.length > 0) {
                                payload.attributes.properties['ufo:vc:rev'] = vcRev.filter(function(item) {
                                    return item.revision !== 'raw-handler';
                                });
                                payload.attributes.properties['ufo:vc:raw:removed'] = true;
                            }
                        }
                    }
                    payload.attributes.properties['event:sizeInKb'] = (0, $wA1y2.default)(payload.attributes.properties);
                    // in order of importance, first one being least important
                    // we can add more fields as necessary
                    interactionMetricsFieldsToTrim = (0, $krUDg.fg)('ufo_remove_featureflags_from_trimmed_fields') ? [
                        'requestInfo',
                        'resourceTimings'
                    ] : [
                        'requestInfo',
                        'featureFlags',
                        'resourceTimings'
                    ]; // Top-level properties that can be trimmed if payload exceeds size limit
                    topLevelFieldsToTrim = [
                        'ufo:pageVisibilityTimeline'
                    ];
                    properties = payload.attributes.properties;
                    interactionMetrics = properties.interactionMetrics;
                    if (!interactionMetrics) {
                        _context.next = 78;
                        break;
                    }
                    _iterator = $72d68f2fee0a7403$var$_createForOfIteratorHelper(interactionMetricsFieldsToTrim);
                    _context.prev = 56;
                    _iterator.s();
                case 58:
                    if ((_step = _iterator.n()).done) {
                        _context.next = 70;
                        break;
                    }
                    field = _step.value;
                    if (!((0, $wA1y2.default)(properties) <= $72d68f2fee0a7403$var$MAX_PAYLOAD_SIZE)) {
                        _context.next = 62;
                        break;
                    }
                    return _context.abrupt("continue", 68);
                case 62:
                    interactionMetrics[field] = undefined;
                    properties['event:isTrimmed'] = true;
                    trimmedFields = properties['event:trimmedFields'];
                    if (!Array.isArray(trimmedFields)) trimmedFields = [];
                    trimmedFields.push("interactionMetrics.".concat(field));
                    properties['event:trimmedFields'] = trimmedFields;
                case 68:
                    _context.next = 58;
                    break;
                case 70:
                    _context.next = 75;
                    break;
                case 72:
                    _context.prev = 72;
                    _context.t7 = _context["catch"](56);
                    _iterator.e(_context.t7);
                case 75:
                    _context.prev = 75;
                    _iterator.f();
                    return _context.finish(75);
                case 78:
                    _i2 = 0, _topLevelFieldsToTrim = topLevelFieldsToTrim;
                case 79:
                    if (!(_i2 < _topLevelFieldsToTrim.length)) {
                        _context.next = 92;
                        break;
                    }
                    _field = _topLevelFieldsToTrim[_i2];
                    if (!((0, $wA1y2.default)(properties) <= $72d68f2fee0a7403$var$MAX_PAYLOAD_SIZE)) {
                        _context.next = 83;
                        break;
                    }
                    return _context.abrupt("continue", 89);
                case 83:
                    properties[_field] = undefined;
                    properties['event:isTrimmed'] = true;
                    _trimmedFields = properties['event:trimmedFields'];
                    if (!Array.isArray(_trimmedFields)) _trimmedFields = [];
                    _trimmedFields.push(_field);
                    properties['event:trimmedFields'] = _trimmedFields;
                case 89:
                    _i2++;
                    _context.next = 79;
                    break;
                case 92:
                    // If the payload size continues to exceed the limit and interactionMetrics is already trimmed,
                    // trim VC debug data (early viewport checkpoints). PIR-30543 - AFO-5033
                    isVCRevisionTrimEnabled = (0, $krUDg.fg)('ufo_vc_revision_trim_enabled');
                    (0, $lINhO.trimVcDebugData)(properties, (0, $wA1y2.default)(properties), $72d68f2fee0a7403$var$MAX_PAYLOAD_SIZE, isVCRevisionTrimEnabled);
                    return _context.abrupt("return", payload);
                case 95:
                case "end":
                    return _context.stop();
            }
        }, _callee, null, [
            [
                56,
                72,
                75,
                78
            ]
        ]);
    }));
    return $72d68f2fee0a7403$var$_createInteractionMetricsPayload.apply(this, arguments);
}
function $72d68f2fee0a7403$export$51b606e6d67c2231(_x6, _x7) {
    return $72d68f2fee0a7403$var$_createPayloads.apply(this, arguments);
}
function $72d68f2fee0a7403$var$_createPayloads() {
    $72d68f2fee0a7403$var$_createPayloads = (0, $cn8ql.default)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5Cxn4))).mark(function _callee2(interactionId, interaction) {
        var ufoNameOverride, modifiedInteraction, config, payloads, isCriticalMetricsEnabled, vcMetrics, criticalMetricsPayloads, criticalPayloadCount, interactionMetricsPayload;
        return (0, (/*@__PURE__*/$parcel$interopDefault($5Cxn4))).wrap(function _callee2$(_context2) {
            while(true)switch(_context2.prev = _context2.next){
                case 0:
                    ufoNameOverride = $72d68f2fee0a7403$var$getUfoNameOverride(interaction);
                    modifiedInteraction = $72d68f2fee0a7403$var$_objectSpread($72d68f2fee0a7403$var$_objectSpread({}, interaction), {}, {
                        ufoName: ufoNameOverride
                    });
                    if (!(0, $krUDg.fg)('platform_ufo_disable_ufo_names_config')) {
                        _context2.next = 6;
                        break;
                    }
                    config = (0, $03EZb.getConfig)();
                    if (!(config !== null && config !== void 0 && config.disabledUfoNames && config !== null && config !== void 0 && config.disabledUfoNames.includes(ufoNameOverride))) {
                        _context2.next = 6;
                        break;
                    }
                    return _context2.abrupt("return", []);
                case 6:
                    payloads = [];
                    isCriticalMetricsEnabled = (0, $krUDg.fg)('platform_ufo_critical_metrics_payload'); // Calculate VC metrics once to avoid duplicate expensive calculations
                    _context2.next = 10;
                    return (0, $ejpCV.default)(interaction);
                case 10:
                    vcMetrics = _context2.sent;
                    if (!isCriticalMetricsEnabled) {
                        _context2.next = 17;
                        break;
                    }
                    _context2.next = 14;
                    return (0, $1odpW.createCriticalMetricsPayloads)(interactionId, interaction, vcMetrics);
                case 14:
                    _context2.t0 = _context2.sent;
                    _context2.next = 18;
                    break;
                case 17:
                    _context2.t0 = [];
                case 18:
                    criticalMetricsPayloads = _context2.t0;
                    payloads.push.apply(payloads, (0, $lFOXD.default)(criticalMetricsPayloads));
                    criticalPayloadCount = isCriticalMetricsEnabled ? criticalMetricsPayloads.length : undefined;
                    _context2.next = 23;
                    return $72d68f2fee0a7403$var$createInteractionMetricsPayload(modifiedInteraction, interactionId, undefined, criticalPayloadCount, vcMetrics);
                case 23:
                    interactionMetricsPayload = _context2.sent;
                    payloads.push(interactionMetricsPayload);
                    return _context2.abrupt("return", payloads.filter(Boolean));
                case 26:
                case "end":
                    return _context2.stop();
            }
        }, _callee2);
    }));
    return $72d68f2fee0a7403$var$_createPayloads.apply(this, arguments);
}
function $72d68f2fee0a7403$export$6410c9ddb2ab201(_x8, _x9) {
    return $72d68f2fee0a7403$var$_createExperimentalMetricsPayload.apply(this, arguments);
}
function $72d68f2fee0a7403$var$_createExperimentalMetricsPayload() {
    $72d68f2fee0a7403$var$_createExperimentalMetricsPayload = (0, $cn8ql.default)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5Cxn4))).mark(function _callee3(interactionId, interaction) {
        var config, ufoName, rate, _config, pageVisibilityState, result;
        return (0, (/*@__PURE__*/$parcel$interopDefault($5Cxn4))).wrap(function _callee3$(_context3) {
            while(true)switch(_context3.prev = _context3.next){
                case 0:
                    config = (0, $03EZb.getConfig)();
                    if (config) {
                        _context3.next = 3;
                        break;
                    }
                    throw Error('UFO Configuration not provided');
                case 3:
                    ufoName = (0, $hij2V.sanitizeUfoName)(interaction.ufoName);
                    rate = (0, $03EZb.getExperimentalInteractionRate)(ufoName, interaction.type);
                    if ((0, $as5v9.default)(rate)) {
                        _context3.next = 7;
                        break;
                    }
                    return _context3.abrupt("return", null);
                case 7:
                    if (!(0, $krUDg.fg)('platform_ufo_disable_ufo_names_config')) {
                        _context3.next = 11;
                        break;
                    }
                    _config = (0, $03EZb.getConfig)();
                    if (!(_config !== null && _config !== void 0 && _config.disabledUfoNames && _config !== null && _config !== void 0 && _config.disabledUfoNames.includes(ufoName))) {
                        _context3.next = 11;
                        break;
                    }
                    return _context3.abrupt("return", null);
                case 11:
                    pageVisibilityState = (0, $4gtBF.getPageVisibilityState)(interaction.start, interaction.end);
                    if (!(pageVisibilityState !== 'visible')) {
                        _context3.next = 14;
                        break;
                    }
                    return _context3.abrupt("return", null);
                case 14:
                    _context3.next = 16;
                    return $72d68f2fee0a7403$var$createInteractionMetricsPayload(interaction, interactionId, true);
                case 16:
                    result = _context3.sent;
                    return _context3.abrupt("return", result);
                case 18:
                case "end":
                    return _context3.stop();
            }
        }, _callee3);
    }));
    return $72d68f2fee0a7403$var$_createExperimentalMetricsPayload.apply(this, arguments);
}
function $72d68f2fee0a7403$export$84796f657a45566d(_x0, _x1) {
    return $72d68f2fee0a7403$var$_createExtraSearchPageInteractionPayload.apply(this, arguments);
}
function $72d68f2fee0a7403$var$_createExtraSearchPageInteractionPayload() {
    $72d68f2fee0a7403$var$_createExtraSearchPageInteractionPayload = (0, $cn8ql.default)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5Cxn4))).mark(function _callee4(interactionId, interaction) {
        var SAIN_HOLD_NAMES, NAME_OVERRIDE, SEARCH_PAGE_SMART_ANSWERS_SEGMENT_LABEL, newInteractionId, newEnd, holdInfo, reactProfilerTimings, lastHold, isLastHoldSAIN, lastFilteredTime, filteredReactProfilerTimings, lastTiming, modifiedInteraction, payloads, vcMetrics, interactionMetricsPayload;
        return (0, (/*@__PURE__*/$parcel$interopDefault($5Cxn4))).wrap(function _callee4$(_context4) {
            while(true)switch(_context4.prev = _context4.next){
                case 0:
                    SAIN_HOLD_NAMES = [
                        'search-ai-dialog-visible-text-loading',
                        'search-ai-dialog-all-text-loading'
                    ];
                    NAME_OVERRIDE = 'search-page-ignoring-smart-answers';
                    SEARCH_PAGE_SMART_ANSWERS_SEGMENT_LABEL = 'search-page-smart-answers';
                    newInteractionId = "".concat(interactionId, "-ignoring-smart-answers"); // Calculate a new end time which excludes SAIN holds
                    holdInfo = interaction.holdInfo, reactProfilerTimings = interaction.reactProfilerTimings;
                    lastHold = holdInfo.at(-1);
                    isLastHoldSAIN = Boolean(lastHold && SAIN_HOLD_NAMES.includes(lastHold.name)); // A new end time is only calculated if the last hold is a SAIN hold
                    if (isLastHoldSAIN) {
                        lastFilteredTime = null;
                        filteredReactProfilerTimings = reactProfilerTimings.filter(function(timing) {
                            if (timing.commitTime === lastFilteredTime) return false;
                            var isTimingSmartAnswersInSearch = timing.labelStack.some(function(label) {
                                return label.name === SEARCH_PAGE_SMART_ANSWERS_SEGMENT_LABEL;
                            });
                            if (isTimingSmartAnswersInSearch) {
                                lastFilteredTime = timing.commitTime;
                                return false;
                            }
                            return true;
                        });
                        lastTiming = filteredReactProfilerTimings.at(-1);
                        if (lastTiming) newEnd = lastTiming.commitTime;
                    }
                    modifiedInteraction = $72d68f2fee0a7403$var$_objectSpread($72d68f2fee0a7403$var$_objectSpread({}, interaction), {}, {
                        end: newEnd !== null && newEnd !== void 0 ? newEnd : interaction.end,
                        holdInfo: [],
                        knownSegments: [],
                        reactProfilerTimings: [],
                        ufoName: NAME_OVERRIDE
                    });
                    payloads = [];
                    _context4.next = 12;
                    return (0, $ejpCV.default)(interaction, false, true);
                case 12:
                    vcMetrics = _context4.sent;
                    _context4.next = 15;
                    return $72d68f2fee0a7403$var$createInteractionMetricsPayload(modifiedInteraction, newInteractionId, undefined, undefined, vcMetrics);
                case 15:
                    interactionMetricsPayload = _context4.sent;
                    payloads.push(interactionMetricsPayload);
                    return _context4.abrupt("return", payloads.filter(Boolean));
                case 18:
                case "end":
                    return _context4.stop();
            }
        }, _callee4);
    }));
    return $72d68f2fee0a7403$var$_createExtraSearchPageInteractionPayload.apply(this, arguments);
}

});
parcelRegister("cH3JV", function(module, exports) {
$parcel$export(module.exports, "CHRReporter", function () { return $93dc66d3ece79437$export$7d0d4cfb6455ffa5; });

var $cTewU = parcelRequire("cTewU");

var $avOEA = parcelRequire("avOEA");

var $f53LC = parcelRequire("f53LC");

var $krUDg = parcelRequire("krUDg");

var $22DFS = parcelRequire("22DFS");
var $93dc66d3ece79437$export$783d6618ee601ba = /*#__PURE__*/ function() {
    function CHRSummary() {
        (0, $cTewU.default)(this, CHRSummary);
        (0, $f53LC.default)(this, "bundles", (0, $f53LC.default)((0, $f53LC.default)((0, $f53LC.default)({}, (0, $22DFS.MEMORY_KEY), 0), (0, $22DFS.DISK_KEY), 0), (0, $22DFS.NETWORK_KEY), 0));
        (0, $f53LC.default)(this, "bundlesCount", 0);
        (0, $f53LC.default)(this, "size", (0, $f53LC.default)((0, $f53LC.default)((0, $f53LC.default)({}, (0, $22DFS.MEMORY_KEY), 0), (0, $22DFS.DISK_KEY), 0), (0, $22DFS.NETWORK_KEY), 0));
        (0, $f53LC.default)(this, "sizeTotal", 0);
    }
    return (0, $avOEA.default)(CHRSummary, [
        {
            key: "add",
            value: function add(asset) {
                var encodedSize = asset.encodedSize || 0;
                var type = (0, $22DFS.calculateTransferType)(asset.name, asset.initiatorType, asset.duration, asset.transferSize);
                if (type === null) return;
                this.bundles[type] += 1;
                this.bundlesCount += 1;
                this.size[type] += encodedSize;
                this.sizeTotal += encodedSize;
            }
        }
    ], [
        {
            key: "makePayload",
            value: function makePayload(summary) {
                var size = summary.size, bundlesCount = summary.bundlesCount, sizeTotal = summary.sizeTotal;
                var cachedSize = size[0, $22DFS.MEMORY_KEY] + size[0, $22DFS.DISK_KEY];
                var sizeRatio = (0, $22DFS.round)(cachedSize / summary.sizeTotal);
                return {
                    size: sizeTotal,
                    chr: sizeRatio,
                    count: bundlesCount
                };
            }
        }
    ]);
}();
var $93dc66d3ece79437$export$7d0d4cfb6455ffa5 = /*#__PURE__*/ function() {
    function CHRReporter() {
        (0, $cTewU.default)(this, CHRReporter);
        (0, $f53LC.default)(this, "all", new $93dc66d3ece79437$export$783d6618ee601ba());
        (0, $f53LC.default)(this, "allAtlassian", new $93dc66d3ece79437$export$783d6618ee601ba());
        (0, $f53LC.default)(this, "preloaded", new $93dc66d3ece79437$export$783d6618ee601ba());
        (0, $f53LC.default)(this, "defaultAllowedTypes", [
            'js'
        ]);
    }
    return (0, $avOEA.default)(CHRReporter, [
        {
            key: "get",
            value: function get(resourceTimings, assetsConfig, SSRDoneTime) {
                var _this = this;
                try {
                    if (resourceTimings === null) return null;
                    resourceTimings.forEach(function(entry) {
                        if (!(0, $22DFS.checkIfTimingsAvailable)(entry)) return;
                        var hasNanValues = (0, $krUDg.fg)('platform_ufo_assets_check_for_nan') ? entry.encodedSize === undefined || entry.encodedSize === null : false;
                        if (entry.encodedSize === entry.decodedSize || hasNanValues) // incorrectly reported or lack of size
                        return;
                        var type = (0, $22DFS.getTypeOfRequest)(entry);
                        if (!(assetsConfig.allowedTypes || _this.defaultAllowedTypes).includes(type)) return;
                        if (assetsConfig.classification.all) _this.all.add(entry);
                        if (assetsConfig.classification.allAtlassian({
                            entry: entry
                        })) _this.allAtlassian.add(entry);
                        if (assetsConfig.classification.preloaded({
                            entry: entry,
                            SSRDoneTime: SSRDoneTime
                        })) _this.preloaded.add(entry);
                    });
                    if (this.all.bundlesCount === 0) return null;
                    var CHRData = {
                        all: $93dc66d3ece79437$export$783d6618ee601ba.makePayload(this.all),
                        allAtlassian: $93dc66d3ece79437$export$783d6618ee601ba.makePayload(this.allAtlassian),
                        preloaded: $93dc66d3ece79437$export$783d6618ee601ba.makePayload(this.preloaded)
                    };
                    return CHRData;
                } catch (_unused) {
                    return null;
                }
            }
        }
    ]);
}();

});
parcelRegister("22DFS", function(module, exports) {
$parcel$export(module.exports, "MEMORY_KEY", function () { return $17ca8b31d137726c$export$22f4983702ea2cc3; });
$parcel$export(module.exports, "DISK_KEY", function () { return $17ca8b31d137726c$export$d85e88075ae28804; });
$parcel$export(module.exports, "NETWORK_KEY", function () { return $17ca8b31d137726c$export$c46019be3f2161d7; });
$parcel$export(module.exports, "calculateTransferType", function () { return $17ca8b31d137726c$export$82deef6698791e4e; });
$parcel$export(module.exports, "getTypeOfRequest", function () { return $17ca8b31d137726c$export$d63396a1f85f70a0; });
$parcel$export(module.exports, "checkIfTimingsAvailable", function () { return $17ca8b31d137726c$export$c67eec4e6ad72694; });
$parcel$export(module.exports, "round", function () { return $17ca8b31d137726c$export$2077e0241d6afd3c; });
/* Borrowed from https://bitbucket.org/atlassian/atlassian-frontend/src/master/packages/performance/browser-metrics/src/plugins/timings/resource.ts */ var $17ca8b31d137726c$export$5e1aa91d6932ddaa = [
    'script',
    'link',
    'other'
];
var $17ca8b31d137726c$export$22f4983702ea2cc3 = 'mem';
var $17ca8b31d137726c$export$d85e88075ae28804 = 'disk';
var $17ca8b31d137726c$export$c46019be3f2161d7 = 'net';
function $17ca8b31d137726c$export$82deef6698791e4e(name, type, duration, size) {
    if (!$17ca8b31d137726c$export$5e1aa91d6932ddaa.includes(type) && !(type === 'other' && name.includes('.js'))) return null;
    if ((size === undefined || size === 0) && duration === 0) return $17ca8b31d137726c$export$22f4983702ea2cc3;
    if (size === 0 && duration > 0) return $17ca8b31d137726c$export$d85e88075ae28804;
    if (size === undefined) return null;
    return $17ca8b31d137726c$export$c46019be3f2161d7;
}
function $17ca8b31d137726c$export$d63396a1f85f70a0(_ref) {
    var name = _ref.name, type = _ref.initiatorType;
    var category = 'other';
    var urlWithoutQuery = name.split('?')[0];
    switch(type){
        case 'script':
            category = 'js';
            break;
        case 'link':
            if (urlWithoutQuery.endsWith('.css')) category = 'css';
            if (urlWithoutQuery.endsWith('.js')) category = 'js';
            break;
        case 'img':
            category = 'image';
            break;
        case 'font':
            category = 'font';
            break;
        default:
            if (urlWithoutQuery.endsWith('.js')) category = 'js';
            else if (urlWithoutQuery.endsWith('.css')) category = 'css';
            else if (urlWithoutQuery.match(/\.(woff|woff2|ttf|otf)$/)) category = 'font';
            else if (urlWithoutQuery.match(/\.(png|jpg|jpeg|gif|svg)$/)) category = 'image';
            break;
    }
    return category;
}
function $17ca8b31d137726c$export$c67eec4e6ad72694(entry) {
    if (entry.decodedSize === 0 && entry.encodedSize === 0 && entry.requestStart === 0 && entry.responseStart === 0) return false;
    return true;
}
function $17ca8b31d137726c$export$2077e0241d6afd3c(n) {
    if (isNaN(n)) return 0;
    return Math.round(n * 10000) / 10000;
}

});


parcelRegister("jS0DY", function(module, exports) {
$parcel$export(module.exports, "getBundleEvalTimings", function () { return $e7738f4dc0946387$export$2eda1519e91a4386; });

var $87kDd = parcelRequire("87kDd");
var $e7738f4dc0946387$var$config = null;
function $e7738f4dc0946387$export$8d21e34596265fa2(bundleEvalTimingConfiguration) {
    $e7738f4dc0946387$var$config = bundleEvalTimingConfiguration;
}
function $e7738f4dc0946387$var$getPerformanceObject() {
    var _window;
    return ((_window = window) !== null && _window !== void 0 ? _window : {}).performance;
}
function $e7738f4dc0946387$export$2eda1519e91a4386(interactionStartTime) {
    if ($e7738f4dc0946387$var$config == null) return {};
    var started = {};
    var timings = {};
    var cachedConfig = $e7738f4dc0946387$var$config;
    var performance = $e7738f4dc0946387$var$getPerformanceObject();
    performance === null || performance === void 0 || performance.getEntriesByType('mark').forEach(function(mark) {
        var result = cachedConfig.mapPerformanceMark(mark.name);
        if (!result) return;
        var type = result.type, name = result.name;
        if (type === 'start' && mark.startTime >= interactionStartTime) {
            started[name] = mark;
            return;
        }
        if (type === 'end' && started[name]) {
            timings[name] = {
                startTime: (0, $87kDd.roundEpsilon)(started[name].startTime - interactionStartTime),
                duration: (0, $87kDd.roundEpsilon)(mark.startTime - started[name].startTime)
            };
            delete started[name];
        }
    });
    if (Object.keys(timings).length === 0) return {};
    return timings;
}

});
parcelRegister("87kDd", function(module, exports) {
$parcel$export(module.exports, "roundEpsilon", function () { return $5e8efb2d16b82543$export$56014375de40214b; });
function $5e8efb2d16b82543$export$56014375de40214b(num) {
    var places = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 3;
    var factor = Math.pow(10, places);
    return Math.round((num + Number.EPSILON) * factor) / factor;
}

});


parcelRegister("bUAr3", function(module, exports) {
$parcel$export(module.exports, "getBm3Timings", function () { return $8ac12ff4b6836583$export$f02972da195a43bb; });

var $1oC0p = parcelRequire("1oC0p");

var $iqOwP = parcelRequire("iqOwP");

var $1BTY2 = parcelRequire("1BTY2");

var $a48Mt = parcelRequire("a48Mt");
function $8ac12ff4b6836583$export$f02972da195a43bb(marks, timingConfigs) {
    var bm3Timings = {};
    if (!marks || !timingConfigs) return bm3Timings;
    timingConfigs.forEach(function(item) {
        if (!item.startMark || !item.endMark) return;
        var startTime = marks[item.startMark];
        if (!startTime) return;
        var endTime = marks[item.endMark];
        if (!endTime) return;
        bm3Timings[item.key] = {
            startTime: startTime,
            endTime: endTime
        };
    });
    return bm3Timings;
}
function $8ac12ff4b6836583$export$30f0b5e5acd268bf(_ref) {
    var marks = _ref.marks, timings = _ref.timings;
    var interactionContext = (0, $1oC0p.useContext)((0, $iqOwP.default));
    var interactionId = (0, $1BTY2.getInteractionId)().current;
    (0, $1oC0p.useMemo)(function() {
        if (interactionContext != null && interactionId != null && marks != null && timings != null) {
            var interactionType = (0, $a48Mt.getCurrentInteractionType)(interactionId);
            if (interactionType === 'press') return;
            var bm3Timings = $8ac12ff4b6836583$export$f02972da195a43bb(marks, timings);
            interactionContext.addCustomTimings(bm3Timings);
        }
    }, [
        interactionContext,
        interactionId,
        marks,
        timings
    ]);
    return null;
}
function $8ac12ff4b6836583$export$d93d677ef2f33c5c(marks, timingsConfig) {
    var interactionId = (0, $1BTY2.getInteractionId)().current;
    if (interactionId) {
        var interactionType = (0, $a48Mt.getCurrentInteractionType)(interactionId);
        if (interactionType === 'press') return;
        var bm3Timings = $8ac12ff4b6836583$export$f02972da195a43bb(marks, timingsConfig);
        (0, $a48Mt.addCustomTiming)(interactionId, [], bm3Timings);
    }
}

});

parcelRegister("bLOdU", function(module, exports) {
$parcel$export(module.exports, "getGlobalErrorCount", function () { return $891b0acb72298a37$export$d06c0426664e7c08; });

var $2zYm4 = parcelRequire("2zYm4");

var $dH1HR = parcelRequire("dH1HR");
var $891b0acb72298a37$var$shouldInitilizeGlobalErrorHandler = true;
var $891b0acb72298a37$var$globalCount = 0;
var $891b0acb72298a37$var$errors = [];
var $891b0acb72298a37$var$push = function push(name, labelStack, errorType, errorMessage, errorStack) {
    $891b0acb72298a37$var$errors.push({
        name: name,
        labelStack: labelStack,
        errorType: errorType,
        errorMessage: errorMessage,
        errorStack: errorStack
    });
};
function $891b0acb72298a37$export$ebe081a8c9bf8176(sinkFunc) {
    $891b0acb72298a37$var$push = sinkFunc;
    $891b0acb72298a37$var$errors.forEach(function(e) {
        sinkFunc(e.name, e.labelStack, e.errorType, e.errorMessage, e.errorStack);
    });
    $891b0acb72298a37$var$errors.length = 0;
}
function $891b0acb72298a37$export$d06c0426664e7c08() {
    return $891b0acb72298a37$var$globalCount;
}
function $891b0acb72298a37$var$handleError(e) {
    var _e$error;
    $891b0acb72298a37$var$globalCount++;
    if (((_e$error = e.error) === null || _e$error === void 0 ? void 0 : _e$error.UFOhasCaught) === undefined) try {
        if (e.error instanceof Error) $891b0acb72298a37$var$push('GlobalErrorHandler', null, e.error.name, e.error.message, e.error.stack);
        else if (e.error) {
            var hint = JSON.stringify(e.error).slice(0, 50);
            $891b0acb72298a37$var$push('GlobalErrorHandler', null, '', "Non error object thrown: ".concat(hint), undefined);
        } else if (e.message !== undefined) {
            var _hint = e.message.slice(0, 50);
            $891b0acb72298a37$var$push('GlobalErrorHandler', null, '', "Non error object thrown: ".concat(_hint), undefined);
        }
        if (e.error && (0, $2zYm4.default)(e.error) === 'object') e.error.UFOhasCaught = true;
    // eslint-disable-next-line no-empty
    } catch (_unused) {}
}
function $891b0acb72298a37$var$handlePromiseRejection(e) {
    $891b0acb72298a37$var$globalCount++;
    if (e.reason instanceof Error) $891b0acb72298a37$var$push('GlobalErrorHandler', null, e.reason.name, e.reason.message, e.reason.stack);
    else if (e.reason) try {
        var hint = JSON.stringify(e.reason).slice(0, 50);
        $891b0acb72298a37$var$push('GlobalErrorHandler', null, '', "Non error object thrown: ".concat(hint), undefined);
    // eslint-disable-next-line no-empty
    } catch (_unused2) {}
}
function $891b0acb72298a37$var$setupUFOGlobalErrorHandler() {
    if ($891b0acb72298a37$var$shouldInitilizeGlobalErrorHandler) {
        (0, $dH1HR.bind)(window, {
            type: 'error',
            listener: function listener(e) {
                return $891b0acb72298a37$var$handleError(e);
            }
        });
        (0, $dH1HR.bind)(window, {
            type: 'unhandledrejection',
            listener: $891b0acb72298a37$var$handlePromiseRejection
        });
        $891b0acb72298a37$var$shouldInitilizeGlobalErrorHandler = false;
    }
}
var $891b0acb72298a37$export$2e2bcd8739ae039 = $891b0acb72298a37$var$setupUFOGlobalErrorHandler;

});

parcelRegister("8pUKJ", function(module, exports) {
$parcel$export(module.exports, "getTimings", function () { return $620cae715848f83f$export$6d488733a547304; });
var $620cae715848f83f$var$timings = [];
function $620cae715848f83f$export$758b9a33800fa436(name, startMark, stopMark) {
    var cleanStart = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
    var cleanStop = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : false;
    $620cae715848f83f$var$timings.push({
        name: name,
        startMark: startMark,
        stopMark: stopMark,
        cleanStart: cleanStart,
        cleanStop: cleanStop
    });
}
function $620cae715848f83f$export$6d488733a547304() {
    var reportedTimingsObj = {};
    $620cae715848f83f$var$timings.forEach(function(_ref) {
        var name = _ref.name, startMark = _ref.startMark, stopMark = _ref.stopMark, cleanStart = _ref.cleanStart, cleanStop = _ref.cleanStop;
        var startEntryList = performance.getEntriesByName(startMark);
        var stopEntryList = performance.getEntriesByName(stopMark);
        if ((startEntryList === null || startEntryList === void 0 ? void 0 : startEntryList.length) > 0 && (stopEntryList === null || stopEntryList === void 0 ? void 0 : stopEntryList.length) > 0) {
            var startEntry = startEntryList[startEntryList.length - 1];
            var stopEntry = stopEntryList[stopEntryList.length - 1];
            var startTime = startEntry.startTime;
            var duration = stopEntry.startTime - startTime;
            var timing = {
                startTime: Math.round(startTime),
                duration: Math.round(duration)
            };
            reportedTimingsObj[name] = timing;
        }
        if (cleanStart) performance.clearMarks(startMark);
        if (cleanStop) performance.clearMarks(stopMark);
    });
    return reportedTimingsObj;
}

});

parcelRegister("d39M6", function(module, exports) {
$parcel$export(module.exports, "getResourceTimings", function () { return $98032347c4da12f4$export$9eebb59359c2e9e5; });

var $f53LC = parcelRequire("f53LC");

var $03EZb = parcelRequire("03EZb");

var $87kDd = parcelRequire("87kDd");

var $gyWh8 = parcelRequire("gyWh8");

var $8Tf4I = parcelRequire("8Tf4I");
function $98032347c4da12f4$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $98032347c4da12f4$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $98032347c4da12f4$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $f53LC.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $98032347c4da12f4$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $98032347c4da12f4$var$alwaysCacheableTypes = [
    'script',
    'link'
];
var $98032347c4da12f4$var$resourceTypes = [
    'fetch',
    'xmlhttprequest'
];
var $98032347c4da12f4$var$CACHE_NETWORK = 'network';
var $98032347c4da12f4$var$CACHE_MEMORY = 'memory';
var $98032347c4da12f4$var$CACHE_DISK = 'disk';
function $98032347c4da12f4$var$isCacheableType(url, type) {
    if ($98032347c4da12f4$var$alwaysCacheableTypes.includes(type)) return true;
    if (type === 'other' && url.includes('.js')) return true;
    return false;
}
// eslint-disable-next-line @typescript-eslint/no-invalid-void-type
function $98032347c4da12f4$var$calculateTransferType(name, type, duration, size) {
    if (!$98032347c4da12f4$var$isCacheableType(name, type)) return $98032347c4da12f4$var$CACHE_NETWORK;
    if ((size === undefined || size === 0) && duration === 0) return $98032347c4da12f4$var$CACHE_MEMORY;
    if (size === 0 && duration > 0) return $98032347c4da12f4$var$CACHE_DISK;
    if (size === undefined) return null;
    return $98032347c4da12f4$var$CACHE_NETWORK;
}
function $98032347c4da12f4$var$getWindowObject() {
    return typeof window !== 'undefined' && !!window ? window : undefined;
}
function $98032347c4da12f4$var$hasAccessToResourceSize(url, type, entry, hasTimingHeaders) {
    return !$98032347c4da12f4$var$isCacheableType(url, type) || url.includes('localhost') || !!$98032347c4da12f4$var$getWindowObject() && url.includes(window.location.hostname) || hasTimingHeaders(url, entry);
}
function $98032347c4da12f4$var$getReportedInitiatorTypes(xhrEnabled) {
    var ufoConfig = (0, $03EZb.getConfig)();
    if (!(ufoConfig !== null && ufoConfig !== void 0 && ufoConfig.allowedResources)) {
        if (xhrEnabled) return [
            'script',
            'link',
            'fetch',
            'other',
            'xmlhttprequest'
        ];
        return [
            'script',
            'link',
            'fetch',
            'other'
        ];
    }
    return ufoConfig.allowedResources;
}
function $98032347c4da12f4$var$evaluateAccessToResourceTimings(_, entry) {
    return !(entry.responseStart === 0 && entry.startTime > entry.responseStart);
}
// eslint-disable-next-line @typescript-eslint/no-invalid-void-type
function $98032347c4da12f4$var$getSizeObject(size) {
    return size !== undefined ? {
        size: size
    } : null;
}
function $98032347c4da12f4$var$getNetworkData(item, eventStart) {
    var hasTimingHeaders = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : $98032347c4da12f4$var$evaluateAccessToResourceTimings;
    var name = item.name, duration = item.duration, transferSize = item.transferSize, initiatorType = item.initiatorType, responseStart = item.responseStart, requestStart = item.requestStart, serverTime = item.serverTime, networkTime = item.networkTime, encodedSize = item.encodedSize, decodedSize = item.decodedSize;
    var ttfb = (0, $87kDd.roundEpsilon)(responseStart - eventStart);
    var requestStartRelative = (0, $87kDd.roundEpsilon)(requestStart - eventStart);
    if (!$98032347c4da12f4$var$hasAccessToResourceSize(name, initiatorType, item, hasTimingHeaders)) return {};
    if ($98032347c4da12f4$var$isCacheableType(name, initiatorType)) {
        var transferType = $98032347c4da12f4$var$calculateTransferType(name, initiatorType, duration, transferSize);
        return $98032347c4da12f4$var$_objectSpread({
            ttfb: ttfb,
            transferType: transferType,
            serverTime: serverTime,
            networkTime: networkTime,
            encodedSize: encodedSize,
            decodedSize: decodedSize
        }, $98032347c4da12f4$var$getSizeObject(transferSize));
    }
    return $98032347c4da12f4$var$_objectSpread({
        ttfb: ttfb,
        serverTime: serverTime,
        networkTime: networkTime,
        requestStart: requestStartRelative
    }, $98032347c4da12f4$var$getSizeObject(transferSize));
}
function $98032347c4da12f4$export$9eebb59359c2e9e5(interactionStart, interactionEnd) {
    var resourceTiming = {};
    if (interactionStart === null) return resourceTiming;
    var resources = (0, $8Tf4I.filterResourceTimings)(interactionStart, interactionEnd);
    if (!(resources !== null && resources !== void 0 && resources.length)) return resourceTiming;
    var _getConfig = (0, $gyWh8.getConfig)(), xhrFilter = _getConfig.xhrFilter, sanitiseEndpoints = _getConfig.sanitiseEndpoints, mapResources = _getConfig.mapResources, hasTimingHeaders = _getConfig.hasTimingHeaders;
    var reportedInitiatorTypes = $98032347c4da12f4$var$getReportedInitiatorTypes(!!xhrFilter);
    resources.forEach(function(item) {
        if (!reportedInitiatorTypes.includes(item.initiatorType)) return;
        var name = item.name, startTime = item.startTime, duration = item.duration, workerStart = item.workerStart, fetchStart = item.fetchStart, initiatorType = item.initiatorType;
        if (!name) return;
        if (initiatorType === 'xmlhttprequest' && (xhrFilter === undefined || xhrFilter(name) === false)) return;
        if (initiatorType === 'other' && !name.includes('.js')) return;
        var url = $98032347c4da12f4$var$resourceTypes.includes(initiatorType) ? sanitiseEndpoints(name) : mapResources(name);
        if (!url) return;
        if (resourceTiming[url]) {
            resourceTiming[url].count = (resourceTiming[url].count || 1) + 1;
            return;
        }
        resourceTiming[url] = $98032347c4da12f4$var$_objectSpread({
            startTime: (0, $87kDd.roundEpsilon)(startTime - interactionStart),
            duration: (0, $87kDd.roundEpsilon)(duration),
            workerStart: Math.max((0, $87kDd.roundEpsilon)(workerStart - interactionStart), 0),
            fetchStart: Math.max((0, $87kDd.roundEpsilon)(fetchStart - interactionStart), 0),
            type: initiatorType
        }, $98032347c4da12f4$var$getNetworkData(item, interactionStart, hasTimingHeaders));
    });
    return resourceTiming;
}

});
parcelRegister("8Tf4I", function(module, exports) {
$parcel$export(module.exports, "filterResourceTimings", function () { return $678f276668dbe34e$export$4138a729ef1db028; });

var $lFOXD = parcelRequire("lFOXD");

var $87kDd = parcelRequire("87kDd");
var $678f276668dbe34e$var$getPerformanceObject = function getPerformanceObject() {
    var _window;
    return ((_window = window) !== null && _window !== void 0 ? _window : {}).performance;
};
var $678f276668dbe34e$var$getPerformanceObserverObject = function getPerformanceObserverObject() {
    var _window2;
    return ((_window2 = window) !== null && _window2 !== void 0 ? _window2 : {}).PerformanceObserver;
};
var $678f276668dbe34e$export$bea963256235a63e = {
    timings: [],
    maxSize: 1000,
    observer: null,
    transformResource: function transformResource(entry) {
        var _entry$serverTiming, _entry$serverTiming2;
        var duration = (0, $87kDd.roundEpsilon)(entry.duration);
        // prioritising atl-edge
        var totalBackendTimeEntry = ((_entry$serverTiming = entry.serverTiming) === null || _entry$serverTiming === void 0 ? void 0 : _entry$serverTiming.find(function(timing) {
            return timing.name === 'atl-edge';
        })) || ((_entry$serverTiming2 = entry.serverTiming) === null || _entry$serverTiming2 === void 0 ? void 0 : _entry$serverTiming2.find(// timing name should come from per-product config in the future
        function(timing) {
            return timing.name === 'total' || timing.name === 'filter-request-papi';
        }));
        var serverTime = totalBackendTimeEntry ? (0, $87kDd.roundEpsilon)(totalBackendTimeEntry.duration) : undefined;
        var networkTime = serverTime ? duration - serverTime : undefined;
        return {
            name: entry.name,
            initiatorType: entry.initiatorType,
            transferSize: entry.transferSize,
            startTime: (0, $87kDd.roundEpsilon)(entry.startTime),
            duration: (0, $87kDd.roundEpsilon)(entry.duration),
            fetchStart: (0, $87kDd.roundEpsilon)(entry.fetchStart || 0),
            workerStart: (0, $87kDd.roundEpsilon)(entry.workerStart || 0),
            responseStart: (0, $87kDd.roundEpsilon)(entry.responseStart || 0),
            requestStart: (0, $87kDd.roundEpsilon)(entry.requestStart || 0),
            serverTime: serverTime,
            networkTime: networkTime,
            encodedSize: (0, $87kDd.roundEpsilon)(entry.encodedBodySize),
            decodedSize: (0, $87kDd.roundEpsilon)(entry.decodedBodySize)
        };
    },
    start: function start() {
        var _performance$getEntri;
        var performance = $678f276668dbe34e$var$getPerformanceObject();
        var PerformanceObserver = $678f276668dbe34e$var$getPerformanceObserverObject();
        if (!PerformanceObserver || !performance || typeof PerformanceObserver === 'undefined') return;
        if ($678f276668dbe34e$export$bea963256235a63e.observer) return;
        var resources = (_performance$getEntri = performance.getEntriesByType) === null || _performance$getEntri === void 0 ? void 0 : _performance$getEntri.call(performance, 'resource');
        if (resources) $678f276668dbe34e$export$bea963256235a63e.timings = resources.map(function(resource) {
            return $678f276668dbe34e$export$bea963256235a63e.transformResource(resource);
        });
        $678f276668dbe34e$export$bea963256235a63e.observer = new PerformanceObserver($678f276668dbe34e$export$bea963256235a63e.addTimings);
        $678f276668dbe34e$export$bea963256235a63e.observer.observe({
            entryTypes: [
                'resource'
            ]
        });
    },
    stop: function stop() {
        if ($678f276668dbe34e$export$bea963256235a63e.observer) {
            $678f276668dbe34e$export$bea963256235a63e.observer.disconnect();
            $678f276668dbe34e$export$bea963256235a63e.observer = null;
        }
        $678f276668dbe34e$export$bea963256235a63e.timings = [];
    },
    addTimings: function addTimings(list) {
        var _resourceTimingBuffer;
        var entries = list.getEntries().map(function(entry) {
            return $678f276668dbe34e$export$bea963256235a63e.transformResource(entry);
        });
        var overflow = $678f276668dbe34e$export$bea963256235a63e.timings.length + entries.length;
        if (overflow > $678f276668dbe34e$export$bea963256235a63e.maxSize) {
            var fieldsToRemove = overflow - $678f276668dbe34e$export$bea963256235a63e.maxSize;
            $678f276668dbe34e$export$bea963256235a63e.timings.splice(0, fieldsToRemove);
        }
        (_resourceTimingBuffer = $678f276668dbe34e$export$bea963256235a63e.timings).push.apply(_resourceTimingBuffer, (0, $lFOXD.default)(entries));
    }
};
function $678f276668dbe34e$var$isValidTiming(timing, startTime, endTime) {
    return timing.startTime >= startTime && timing.startTime + timing.duration <= endTime;
}
function $678f276668dbe34e$export$4138a729ef1db028(startTime, endTime) {
    var performance = $678f276668dbe34e$var$getPerformanceObject();
    var PerformanceObserver = $678f276668dbe34e$var$getPerformanceObserverObject();
    if (!PerformanceObserver || !$678f276668dbe34e$export$bea963256235a63e.observer) {
        var resources = performance === null || performance === void 0 ? void 0 : performance.getEntriesByType('resource');
        if (resources) return resources.filter(function(timing) {
            return $678f276668dbe34e$var$isValidTiming(timing, startTime, endTime);
        });
        return null;
    }
    return $678f276668dbe34e$export$bea963256235a63e.timings.filter(function(timing) {
        return $678f276668dbe34e$var$isValidTiming(timing, startTime, endTime);
    });
}

});


parcelRegister("1odpW", function(module, exports) {
$parcel$export(module.exports, "createCriticalMetricsPayloads", function () { return $103270bb52161723$export$dbc5b5c3cadc26f7; });

var $lFOXD = parcelRequire("lFOXD");

var $2qaZZ = parcelRequire("2qaZZ");

var $cn8ql = parcelRequire("cn8ql");

var $5Cxn4 = parcelRequire("5Cxn4");

var $krUDg = parcelRequire("krUDg");

var $jqITx = parcelRequire("jqITx");

var $aYkfK = parcelRequire("aYkfK");
function $103270bb52161723$export$dbc5b5c3cadc26f7(_x, _x2, _x3) {
    return $103270bb52161723$var$_createCriticalMetricsPayloads.apply(this, arguments);
}
function $103270bb52161723$var$_createCriticalMetricsPayloads() {
    $103270bb52161723$var$_createCriticalMetricsPayloads = (0, $cn8ql.default)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5Cxn4))).mark(function _callee(interactionId, interaction, vcMetrics) {
        var _yield$Promise$all, _yield$Promise$all2, rootPayload, segmentPayloads;
        return (0, (/*@__PURE__*/$parcel$interopDefault($5Cxn4))).wrap(function _callee$(_context) {
            while(true)switch(_context.prev = _context.next){
                case 0:
                    _context.next = 2;
                    return Promise.all([
                        (0, $jqITx.createRootCriticalMetricsPayload)(interactionId, interaction, vcMetrics),
                        (0, $krUDg.fg)('platform_ufo_segment_critical_metrics') ? (0, $aYkfK.createSegmentMetricsPayloads)(interactionId, interaction) : []
                    ]);
                case 2:
                    _yield$Promise$all = _context.sent;
                    _yield$Promise$all2 = (0, $2qaZZ.default)(_yield$Promise$all, 2);
                    rootPayload = _yield$Promise$all2[0];
                    segmentPayloads = _yield$Promise$all2[1];
                    return _context.abrupt("return", [
                        rootPayload
                    ].concat((0, $lFOXD.default)(segmentPayloads)).filter(function(v) {
                        return v != null;
                    }));
                case 7:
                case "end":
                    return _context.stop();
            }
        }, _callee);
    }));
    return $103270bb52161723$var$_createCriticalMetricsPayloads.apply(this, arguments);
}

});
parcelRegister("jqITx", function(module, exports) {
$parcel$export(module.exports, "createRootCriticalMetricsPayload", function () { return $e2534532b1537bac$export$2b2c445402a6f795; });

var $f53LC = parcelRequire("f53LC");

var $cn8ql = parcelRequire("cn8ql");

var $5Cxn4 = parcelRequire("5Cxn4");

var $ceERr = parcelRequire("ceERr");

var $03EZb = parcelRequire("03EZb");

var $4gtBF = parcelRequire("4gtBF");

var $hij2V = parcelRequire("hij2V");

var $8y3c7 = parcelRequire("8y3c7");

var $2fnaO = parcelRequire("2fnaO");

var $g5BNF = parcelRequire("g5BNF");

var $4CyF2 = parcelRequire("4CyF2");

var $jmxTP = parcelRequire("jmxTP");

var $dCpJh = parcelRequire("dCpJh");

var $gzPfK = parcelRequire("gzPfK");

var $jdiim = parcelRequire("jdiim");

var $6m6U8 = parcelRequire("6m6U8");

var $7fwel = parcelRequire("7fwel");

var $ejpCV = parcelRequire("ejpCV");
function $e2534532b1537bac$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $e2534532b1537bac$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $e2534532b1537bac$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $f53LC.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $e2534532b1537bac$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
// Re-export types for convenience
// Local utility functions
function $e2534532b1537bac$var$getPageVisibilityUpToTTI(interaction) {
    var _interaction$apdex$0$, _interaction$apdex;
    var start = interaction.start;
    var bm3EndTimeOrInteractionEndTime = (_interaction$apdex$0$ = (_interaction$apdex = interaction.apdex) === null || _interaction$apdex === void 0 || (_interaction$apdex = _interaction$apdex[0]) === null || _interaction$apdex === void 0 ? void 0 : _interaction$apdex.stopTime) !== null && _interaction$apdex$0$ !== void 0 ? _interaction$apdex$0$ : interaction.end;
    return (0, $4gtBF.getPageVisibilityState)(start, bm3EndTimeOrInteractionEndTime);
}
function $e2534532b1537bac$export$2b2c445402a6f795(_x, _x2, _x3) {
    return $e2534532b1537bac$var$_createRootCriticalMetricsPayload.apply(this, arguments);
}
function $e2534532b1537bac$var$_createRootCriticalMetricsPayload() {
    $e2534532b1537bac$var$_createRootCriticalMetricsPayload = (0, $cn8ql.default)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5Cxn4))).mark(function _callee(interactionId, interaction, vcMetrics) {
        var _finalVCMetrics$ufoV, _interaction$cohortin, _window$location;
        var config, end, start, ufoName, rate, type, abortReason, routeName, previousInteractionName, isPreviousInteractionAborted, abortedByInteractionName, holdInfo, responsiveness, pageVisibilityAtTTI, pageVisibilityAtTTAI, interactionStatus, newUFOName, ttai, paintMetrics, navigationMetrics, ssrSuccess, tti, fmp, browserMetadata, lighthouseMetrics, finalVCMetrics, ttvc, earliestHold, cohortingCustomData, properties, payload;
        return (0, (/*@__PURE__*/$parcel$interopDefault($5Cxn4))).wrap(function _callee$(_context) {
            while(true)switch(_context.prev = _context.next){
                case 0:
                    config = (0, $03EZb.getConfig)();
                    if (config) {
                        _context.next = 3;
                        break;
                    }
                    throw Error('UFO Configuration not provided');
                case 3:
                    end = interaction.end, start = interaction.start, ufoName = interaction.ufoName, rate = interaction.rate, type = interaction.type, abortReason = interaction.abortReason, routeName = interaction.routeName, previousInteractionName = interaction.previousInteractionName, isPreviousInteractionAborted = interaction.isPreviousInteractionAborted, abortedByInteractionName = interaction.abortedByInteractionName, holdInfo = interaction.holdInfo, responsiveness = interaction.responsiveness;
                    pageVisibilityAtTTI = $e2534532b1537bac$var$getPageVisibilityUpToTTI(interaction);
                    pageVisibilityAtTTAI = (0, $jmxTP.default)(interaction);
                    interactionStatus = (0, $g5BNF.default)(interaction);
                    if (!(interactionStatus.originalInteractionStatus !== 'SUCCEEDED')) {
                        _context.next = 9;
                        break;
                    }
                    return _context.abrupt("return", null);
                case 9:
                    newUFOName = (0, $hij2V.sanitizeUfoName)(ufoName); // Get performance metrics
                    ttai = (0, $6m6U8.default)(interaction);
                    _context.next = 13;
                    return (0, $dCpJh.default)(type, end);
                case 13:
                    paintMetrics = _context.sent;
                    navigationMetrics = (0, $4CyF2.default)(type);
                    ssrSuccess = (0, $jdiim.default)(type); // Calculate BM3 metrics (TTI and FMP) directly
                    tti = (0, $7fwel.getTTI)(interaction, newUFOName);
                    fmp = (0, $2fnaO.getFMP)(interaction, newUFOName); // Get browser metadata (using compact nested format)
                    browserMetadata = (0, $8y3c7.default)();
                    lighthouseMetrics = (0, $ceERr.getLighthouseMetrics)({
                        start: start,
                        stop: end
                    }); // Use provided vcMetrics or calculate if not provided
                    _context.t0 = vcMetrics;
                    if (_context.t0) {
                        _context.next = 25;
                        break;
                    }
                    _context.next = 24;
                    return (0, $ejpCV.default)(interaction);
                case 24:
                    _context.t0 = _context.sent;
                case 25:
                    finalVCMetrics = _context.t0;
                    ttvc = (_finalVCMetrics$ufoV = finalVCMetrics['ufo:vc:rev']) === null || _finalVCMetrics$ufoV === void 0 ? void 0 : _finalVCMetrics$ufoV.map(function(revision) {
                        if (revision['metric:vc90'] === null || revision.clean !== true) return null;
                        return {
                            revision: revision.revision,
                            vc90: revision['metric:vc90']
                        };
                    }).filter(function(revision) {
                        return revision != null;
                    }); // find earliest hold
                    earliestHold = holdInfo === null || holdInfo === void 0 ? void 0 : holdInfo.reduce(function(a, b) {
                        if (a && a.start < b.start) return a;
                        return b;
                    }, null); // Process cohorting custom data
                    cohortingCustomData = (_interaction$cohortin = interaction.cohortingCustomData) !== null && _interaction$cohortin !== void 0 && _interaction$cohortin.size ? Object.fromEntries(interaction.cohortingCustomData) : undefined;
                    properties = $e2534532b1537bac$var$_objectSpread($e2534532b1537bac$var$_objectSpread({
                        // Basic metadata
                        'event:hostname': ((_window$location = window.location) === null || _window$location === void 0 ? void 0 : _window$location.hostname) || 'unknown',
                        'event:product': config.product,
                        'event:schema': '1.0.0',
                        'event:region': config.region || 'unknown',
                        'event:source': {
                            name: 'react-ufo/web',
                            version: (0, $gzPfK.LATEST_REACT_UFO_PAYLOAD_VERSION)
                        },
                        'experience:key': 'custom.ufo.critical-metrics',
                        'experience:name': newUFOName,
                        // Browser metadata (compact nested format)
                        browser: browserMetadata.browser,
                        device: browserMetadata.device,
                        network: browserMetadata.network,
                        time: browserMetadata.time,
                        metrics: $e2534532b1537bac$var$_objectSpread({
                            fp: paintMetrics.fp,
                            fcp: paintMetrics.fcp,
                            lcp: paintMetrics.lcp,
                            ttai: ttai,
                            tti: tti,
                            fmp: fmp,
                            tbt: lighthouseMetrics['metric:tbt'],
                            tbtObserved: lighthouseMetrics['metric:tbt:observed'],
                            cls: lighthouseMetrics['metric:cls'],
                            ttvc: ttvc !== null && ttvc !== void 0 ? ttvc : undefined,
                            earliestHoldStart: earliestHold !== null && earliestHold !== void 0 && earliestHold.start ? Math.round(earliestHold.start - start) : undefined,
                            // for interaction response
                            inputDelay: responsiveness !== null && responsiveness !== void 0 && responsiveness.inputDelay ? Math.round(responsiveness.inputDelay) : undefined,
                            inp: responsiveness !== null && responsiveness !== void 0 && responsiveness.experimentalInputToNextPaint ? Math.round(responsiveness.experimentalInputToNextPaint) : undefined
                        }, navigationMetrics && {
                            navigation: navigationMetrics
                        })
                    }, ssrSuccess !== undefined && {
                        ssrSuccess: ssrSuccess
                    }), {}, {
                        interactionId: interactionId,
                        type: type,
                        rate: rate,
                        routeName: routeName !== null && routeName !== void 0 ? routeName : undefined,
                        // Performance timings
                        start: Math.round(start),
                        end: Math.round(end),
                        // Status and outcome
                        status: interactionStatus.originalInteractionStatus,
                        abortReason: abortReason,
                        previousInteractionName: previousInteractionName,
                        isPreviousInteractionAborted: isPreviousInteractionAborted,
                        abortedByInteractionName: abortedByInteractionName,
                        pageVisibilityAtTTI: pageVisibilityAtTTI !== null && pageVisibilityAtTTI !== void 0 ? pageVisibilityAtTTI : undefined,
                        pageVisibilityAtTTAI: pageVisibilityAtTTAI,
                        // Basic error count (not detailed error count)
                        errorCount: interaction.errors.length
                    }, Object.keys(cohortingCustomData || {}).length > 0 && {
                        cohortingCustomData: cohortingCustomData
                    });
                    payload = {
                        actionSubject: 'experience',
                        action: 'measured',
                        eventType: 'operational',
                        source: 'measured',
                        tags: [
                            'observability'
                        ],
                        attributes: {
                            properties: properties
                        }
                    };
                    return _context.abrupt("return", payload);
                case 32:
                case "end":
                    return _context.stop();
            }
        }, _callee);
    }));
    return $e2534532b1537bac$var$_createRootCriticalMetricsPayload.apply(this, arguments);
}

});
parcelRegister("8y3c7", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $6393fa153fe5881f$export$2e2bcd8739ae039; });
$parcel$export(module.exports, "getBrowserMetadataToLegacyFormat", function () { return $6393fa153fe5881f$export$adab82a5a24aa23e; });

var $8oqW7 = parcelRequire("8oqW7");
function $6393fa153fe5881f$export$2e2bcd8739ae039() {
    var data = {
        time: {
            localHour: 0,
            localDayOfWeek: 0,
            localTimezoneOffset: 0
        }
    };
    var now = new Date();
    data.time.localHour = now.getHours(); // returns the hours for this date according to local time
    data.time.localDayOfWeek = now.getDay(); // Sunday - Saturday : 0 - 6
    data.time.localTimezoneOffset = now.getTimezoneOffset(); // A number representing the difference, in minutes, between the date as evaluated in the UTC time zone and as evaluated in the local time zone.
    if (typeof navigator !== 'undefined' && navigator.userAgent != null) {
        var browser = (0, (/*@__PURE__*/$parcel$interopDefault($8oqW7))).getParser(navigator.userAgent);
        data.browser = {
            name: browser.getBrowserName(),
            version: browser.getBrowserVersion()
        };
    }
    if (typeof navigator !== 'undefined' && navigator.hardwareConcurrency != null) {
        if (!data.device) data.device = {};
        data.device.cpus = navigator.hardwareConcurrency;
    }
    if (typeof navigator !== 'undefined' && navigator.deviceMemory != null) {
        if (!data.device) data.device = {};
        data.device.memory = navigator.deviceMemory;
    }
    // eslint-disable-next-line compat/compat
    if (typeof navigator !== 'undefined' && navigator.connection != null) data.network = {
        effectiveType: navigator.connection.effectiveType,
        rtt: navigator.connection.rtt,
        downlink: navigator.connection.downlink
    };
    if (typeof navigator !== 'undefined') data.webdriver = Boolean(navigator.webdriver);
    return data;
}
function $6393fa153fe5881f$export$adab82a5a24aa23e() {
    var metadata = $6393fa153fe5881f$export$2e2bcd8739ae039();
    var legacyFormat = {};
    // Time data
    legacyFormat['event:localHour'] = metadata.time.localHour;
    legacyFormat['event:localDayOfWeek'] = metadata.time.localDayOfWeek;
    legacyFormat['event:localTimezoneOffset'] = metadata.time.localTimezoneOffset;
    // Browser data
    if (metadata.browser) {
        legacyFormat['event:browser:name'] = metadata.browser.name;
        legacyFormat['event:browser:version'] = metadata.browser.version;
    }
    // Webdriver data
    if (metadata.webdriver !== undefined) legacyFormat['event:browser:webdriver'] = metadata.webdriver;
    // Device data
    if (metadata.device) {
        if (metadata.device.cpus !== undefined) legacyFormat['event:cpus'] = metadata.device.cpus;
        if (metadata.device.memory !== undefined) legacyFormat['event:memory'] = metadata.device.memory;
    }
    // Network data
    if (metadata.network) {
        legacyFormat['event:network:effectiveType'] = metadata.network.effectiveType;
        legacyFormat['event:network:rtt'] = metadata.network.rtt;
        legacyFormat['event:network:downlink'] = metadata.network.downlink;
    }
    return legacyFormat;
}

});

parcelRegister("2fnaO", function(module, exports) {
$parcel$export(module.exports, "getFMP", function () { return $1a2ef541a2f73c9e$export$b98bf736a4892f95; });

var $03EZb = parcelRequire("03EZb");

var $18ZRU = parcelRequire("18ZRU");
function $1a2ef541a2f73c9e$export$b98bf736a4892f95(interaction, experienceName) {
    var _config$ssr, _config$ssr$getSSRDon, _config$ssr2;
    var start = interaction.start, type = interaction.type, marks = interaction.marks;
    var config = (0, $03EZb.getConfig)();
    var ssrDoneTime = config === null || config === void 0 || (_config$ssr = config.ssr) === null || _config$ssr === void 0 || (_config$ssr$getSSRDon = _config$ssr.getSSRDoneTime) === null || _config$ssr$getSSRDon === void 0 ? void 0 : _config$ssr$getSSRDon.call(_config$ssr);
    var isBM3ConfigSSRDoneAsFmp = interaction.metaData.__legacy__bm3ConfigSSRDoneAsFmp;
    var isUFOConfigSSRDoneAsFmp = interaction.metaData.__legacy__bm3ConfigSSRDoneAsFmp || !!(config !== null && config !== void 0 && (_config$ssr2 = config.ssr) !== null && _config$ssr2 !== void 0 && _config$ssr2.getSSRDoneTime);
    // Find matching legacy metric
    var matchingLegacyMetric = (0, $18ZRU.findMatchingLegacyMetric)(interaction, experienceName);
    var fmp;
    if (type === 'page_load' || type === 'transition') {
        if (interaction.legacyMetrics && matchingLegacyMetric) {
            // Check if legacy metric has FMP
            var legacyFmp = matchingLegacyMetric.fmp; // BM3Event doesn't have fmp in types, but it might exist
            if (legacyFmp) fmp = Math.round(legacyFmp - start);
        // If no FMP in legacy metric, return undefined (don't calculate fallback)
        }
    }
    if (type === 'page_load' && fmp === undefined) {
        if (isBM3ConfigSSRDoneAsFmp || isUFOConfigSSRDoneAsFmp) {
            var _marks$find;
            var foundMark = marks === null || marks === void 0 || (_marks$find = marks.find(function(mark) {
                return mark.name === 'fmp';
            })) === null || _marks$find === void 0 ? void 0 : _marks$find.time;
            if (foundMark) fmp = Math.round(foundMark - start);
            else if (ssrDoneTime) fmp = Math.round(ssrDoneTime - start);
        // If no FMP mark and no SSR done time, fmp remains undefined
        }
    }
    return fmp;
}

});
parcelRegister("18ZRU", function(module, exports) {
$parcel$export(module.exports, "findMatchingLegacyMetric", function () { return $0d5687986685e3ad$export$9e0d04c44e1b23f6; });
/**
 * Find matching legacy metric by experience name and type
 */ function $0d5687986685e3ad$export$9e0d04c44e1b23f6(interaction, experienceName) {
    var _interaction$legacyMe;
    return (_interaction$legacyMe = interaction.legacyMetrics) === null || _interaction$legacyMe === void 0 ? void 0 : _interaction$legacyMe.find(function(metric) {
        return (metric.key === experienceName || metric.config.reactUFOName === experienceName) && metric.type === 'PAGE_LOAD';
    });
}

});


parcelRegister("4CyF2", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $35d598f57b7ea4a8$export$2e2bcd8739ae039; });
$parcel$export(module.exports, "getNavigationMetricsToLegacyFormat", function () { return $35d598f57b7ea4a8$export$5f36f2643451c683; });
function $35d598f57b7ea4a8$export$2e2bcd8739ae039(type) {
    if (type !== 'page_load') return null;
    try {
        var entries = performance.getEntriesByType('navigation');
        if (entries.length === 0) return null;
        var navigation = entries[0];
        return {
            // From https://www.w3.org/TR/resource-timing/
            redirectStart: Math.round(navigation.redirectStart),
            redirectEnd: Math.round(navigation.redirectEnd),
            fetchStart: Math.round(navigation.fetchStart),
            domainLookupStart: Math.round(navigation.domainLookupStart),
            domainLookupEnd: Math.round(navigation.domainLookupEnd),
            connectStart: Math.round(navigation.connectStart),
            connectEnd: Math.round(navigation.connectEnd),
            secureConnectionStart: Math.round(navigation.secureConnectionStart),
            requestStart: Math.round(navigation.requestStart),
            responseStart: Math.round(navigation.responseStart),
            responseEnd: Math.round(navigation.responseEnd),
            encodedBodySize: Math.round(navigation.encodedBodySize),
            decodedBodySize: Math.round(navigation.decodedBodySize),
            transferSize: Math.round(navigation.transferSize),
            // From https://www.w3.org/TR/navigation-timing-2/
            redirectCount: navigation.redirectCount,
            type: navigation.type,
            unloadEventEnd: Math.round(navigation.unloadEventEnd),
            unloadEventStart: Math.round(navigation.unloadEventStart),
            workerStart: Math.round(navigation.workerStart),
            nextHopProtocol: navigation.nextHopProtocol
        };
    } catch (_unused) {
        // Return null if there's any error accessing navigation timing
        return null;
    }
}
function $35d598f57b7ea4a8$export$5f36f2643451c683(type) {
    var navigationMetrics = $35d598f57b7ea4a8$export$2e2bcd8739ae039(type);
    if (!navigationMetrics) return {};
    return {
        'metrics:navigation': navigationMetrics
    };
}

});

parcelRegister("dCpJh", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $9ea2c848aab4f97b$export$2e2bcd8739ae039; });
$parcel$export(module.exports, "getPaintMetricsToLegacyFormat", function () { return $9ea2c848aab4f97b$export$3a01cabaa43622d; });

var $cn8ql = parcelRequire("cn8ql");

var $5Cxn4 = parcelRequire("5Cxn4");
function $9ea2c848aab4f97b$export$2e2bcd8739ae039(_x, _x2) {
    return $9ea2c848aab4f97b$var$_getPaintMetrics.apply(this, arguments);
}
// Helper function to get paint metrics in legacy colon format for backward compatibility
function $9ea2c848aab4f97b$var$_getPaintMetrics() {
    $9ea2c848aab4f97b$var$_getPaintMetrics = (0, $cn8ql.default)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5Cxn4))).mark(function _callee(type, end) {
        var paint, paintEntries, lcp;
        return (0, (/*@__PURE__*/$parcel$interopDefault($5Cxn4))).wrap(function _callee$(_context) {
            while(true)switch(_context.prev = _context.next){
                case 0:
                    if (!(type !== 'page_load')) {
                        _context.next = 2;
                        break;
                    }
                    return _context.abrupt("return", {});
                case 2:
                    paint = {};
                    paintEntries = performance.getEntriesByType('paint');
                    paintEntries.forEach(function(entry) {
                        if (entry.name === 'first-paint') paint.fp = Math.round(entry.startTime);
                        if (entry.name === 'first-contentful-paint') paint.fcp = Math.round(entry.startTime);
                    });
                    // Get LCP using PerformanceObserver
                    _context.next = 7;
                    return new Promise(function(resolve) {
                        // Check if we already have LCP entries
                        var existingEntries = performance.getEntriesByType('largest-contentful-paint');
                        var lastEntry = existingEntries.reduce(function(agg, entry) {
                            if (entry.startTime <= end && (agg === null || agg.startTime < entry.startTime)) return entry;
                            return agg;
                        }, null);
                        if (lastEntry) {
                            resolve(lastEntry.startTime);
                            return;
                        }
                        var observer = new PerformanceObserver(function(list) {
                            var entries = Array.from(list.getEntries());
                            var lastEntry = entries.reduce(function(agg, entry) {
                                if (entry.startTime <= end && (agg === null || agg.startTime < entry.startTime)) return entry;
                                return agg;
                            }, null);
                            clearTimeout(timeoutId);
                            observer.disconnect();
                            if (lastEntry) resolve(lastEntry.startTime);
                            else resolve(null);
                        });
                        observer.observe({
                            type: 'largest-contentful-paint',
                            buffered: true
                        });
                        var timeoutId = setTimeout(function() {
                            observer.disconnect();
                            resolve(null);
                        }, 200);
                    });
                case 7:
                    lcp = _context.sent;
                    if (lcp) paint.lcp = Math.round(lcp);
                    return _context.abrupt("return", paint);
                case 10:
                case "end":
                    return _context.stop();
            }
        }, _callee);
    }));
    return $9ea2c848aab4f97b$var$_getPaintMetrics.apply(this, arguments);
}
function $9ea2c848aab4f97b$export$3a01cabaa43622d(_x3, _x4) {
    return $9ea2c848aab4f97b$var$_getPaintMetricsToLegacyFormat.apply(this, arguments);
}
function $9ea2c848aab4f97b$var$_getPaintMetricsToLegacyFormat() {
    $9ea2c848aab4f97b$var$_getPaintMetricsToLegacyFormat = (0, $cn8ql.default)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5Cxn4))).mark(function _callee2(type, end) {
        var paint, legacyFormat;
        return (0, (/*@__PURE__*/$parcel$interopDefault($5Cxn4))).wrap(function _callee2$(_context2) {
            while(true)switch(_context2.prev = _context2.next){
                case 0:
                    _context2.next = 2;
                    return $9ea2c848aab4f97b$export$2e2bcd8739ae039(type, end);
                case 2:
                    paint = _context2.sent;
                    legacyFormat = {};
                    if (paint.fp !== undefined) legacyFormat['metric:fp'] = paint.fp;
                    if (paint.fcp !== undefined) legacyFormat['metric:fcp'] = paint.fcp;
                    if (paint.lcp !== undefined) legacyFormat['metric:lcp'] = paint.lcp;
                    return _context2.abrupt("return", legacyFormat);
                case 8:
                case "end":
                    return _context2.stop();
            }
        }, _callee2);
    }));
    return $9ea2c848aab4f97b$var$_getPaintMetricsToLegacyFormat.apply(this, arguments);
}

});

parcelRegister("gzPfK", function(module, exports) {
$parcel$export(module.exports, "LATEST_REACT_UFO_PAYLOAD_VERSION", function () { return $c117ac018a6e5bfd$export$e919e900fc2d7fe8; });
$parcel$export(module.exports, "getReactUFOPayloadVersion", function () { return $c117ac018a6e5bfd$export$159168550e7449b8; });
var $c117ac018a6e5bfd$export$e919e900fc2d7fe8 = '2.0.0';
function $c117ac018a6e5bfd$export$159168550e7449b8(interactionType, isPostInteractionLog) {
    if (isPostInteractionLog) return '1.0.1';
    if (interactionType !== 'page_load' && interactionType !== 'transition') return '1.0.1';
    return $c117ac018a6e5bfd$export$e919e900fc2d7fe8;
}

});

parcelRegister("jdiim", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $dfcd6c3bb88c8918$export$2e2bcd8739ae039; });

var $1CoTB = parcelRequire("1CoTB");
function $dfcd6c3bb88c8918$export$2e2bcd8739ae039(type) {
    if (type !== 'page_load') return undefined;
    return $1CoTB.getSSRSuccess();
}

});

parcelRegister("7fwel", function(module, exports) {
$parcel$export(module.exports, "getTTI", function () { return $015cb147e09ba3fe$export$84423319631a27a0; });

var $18ZRU = parcelRequire("18ZRU");
function $015cb147e09ba3fe$export$84423319631a27a0(interaction, experienceName) {
    var _apdex$;
    var start = interaction.start, end = interaction.end, apdex = interaction.apdex;
    // Find matching legacy metric
    var matchingLegacyMetric = (0, $18ZRU.findMatchingLegacyMetric)(interaction, experienceName);
    // Get end times in priority order (following server-side logic)
    var apdexEndTime = apdex === null || apdex === void 0 || (_apdex$ = apdex[0]) === null || _apdex$ === void 0 ? void 0 : _apdex$.stopTime;
    var legacyMetricsEndTime = matchingLegacyMetric === null || matchingLegacyMetric === void 0 ? void 0 : matchingLegacyMetric.stop;
    var ufoEndTime = end;
    var ttiEndTime;
    if (matchingLegacyMetric && legacyMetricsEndTime) // Use legacy metrics end time if we have a matching legacy metric
    ttiEndTime = legacyMetricsEndTime;
    else if (apdexEndTime) // Fall back to apdex end time if no matching legacy metrics
    ttiEndTime = apdexEndTime;
    else // Final fallback to UFO end time
    ttiEndTime = ufoEndTime;
    return ttiEndTime ? Math.round(ttiEndTime - start) : undefined;
}

});


parcelRegister("aYkfK", function(module, exports) {
$parcel$export(module.exports, "createSegmentMetricsPayloads", function () { return $7fcf37ca78866e6a$export$267f7174399ab737; });

var $f53LC = parcelRequire("f53LC");

var $cn8ql = parcelRequire("cn8ql");

var $5Cxn4 = parcelRequire("5Cxn4");

var $03EZb = parcelRequire("03EZb");

var $8y3c7 = parcelRequire("8y3c7");

var $jmxTP = parcelRequire("jmxTP");

var $gzPfK = parcelRequire("gzPfK");

var $dfr9R = parcelRequire("dfr9R");

var $4pcAq = parcelRequire("4pcAq");

var $bexUI = parcelRequire("bexUI");
function $7fcf37ca78866e6a$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $7fcf37ca78866e6a$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $7fcf37ca78866e6a$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $f53LC.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $7fcf37ca78866e6a$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $7fcf37ca78866e6a$var$_createForOfIteratorHelper(r, e) {
    var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (!t) {
        if (Array.isArray(r) || (t = $7fcf37ca78866e6a$var$_unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) {
            t && (r = t);
            var _n = 0, F = function F() {};
            return {
                s: F,
                n: function n() {
                    return _n >= r.length ? {
                        done: !0
                    } : {
                        done: !1,
                        value: r[_n++]
                    };
                },
                e: function e(r) {
                    throw r;
                },
                f: F
            };
        }
        throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }
    var o, a = !0, u = !1;
    return {
        s: function s() {
            t = t.call(r);
        },
        n: function n() {
            var r = t.next();
            return a = r.done, r;
        },
        e: function e(r) {
            u = !0, o = r;
        },
        f: function f() {
            try {
                a || null == t.return || t.return();
            } finally{
                if (u) throw o;
            }
        }
    };
}
function $7fcf37ca78866e6a$var$_unsupportedIterableToArray(r, a) {
    if (r) {
        if ("string" == typeof r) return $7fcf37ca78866e6a$var$_arrayLikeToArray(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? $7fcf37ca78866e6a$var$_arrayLikeToArray(r, a) : void 0;
    }
}
function $7fcf37ca78866e6a$var$_arrayLikeToArray(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}
function $7fcf37ca78866e6a$export$267f7174399ab737(_x, _x2) {
    return $7fcf37ca78866e6a$var$_createSegmentMetricsPayloads.apply(this, arguments);
}
function $7fcf37ca78866e6a$var$_createSegmentMetricsPayloads() {
    $7fcf37ca78866e6a$var$_createSegmentMetricsPayloads = (0, $cn8ql.default)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5Cxn4))).mark(function _callee(interactionId, interaction) {
        var _interaction$cohortin;
        var config, browserMetadata, cohortingCustomData, pageVisibilityAtTTAI, knownSegments, reactProfilerTimings, rate, routeName, previousInteractionName, isPreviousInteractionAborted, abortedByInteractionName, segmentsByName, _iterator, _step, _loop, _ret, payloads, _iterator2, _step2, _loop2, _ret2;
        return (0, (/*@__PURE__*/$parcel$interopDefault($5Cxn4))).wrap(function _callee$(_context3) {
            while(true)switch(_context3.prev = _context3.next){
                case 0:
                    config = (0, $03EZb.getConfig)();
                    if (config) {
                        _context3.next = 3;
                        break;
                    }
                    throw Error('UFO Configuration not provided');
                case 3:
                    // Get browser metadata (using compact nested format)
                    browserMetadata = (0, $8y3c7.default)(); // Process cohorting custom data
                    cohortingCustomData = (_interaction$cohortin = interaction.cohortingCustomData) !== null && _interaction$cohortin !== void 0 && _interaction$cohortin.size ? Object.fromEntries(interaction.cohortingCustomData) : undefined;
                    pageVisibilityAtTTAI = (0, $jmxTP.default)(interaction);
                    knownSegments = interaction.knownSegments, reactProfilerTimings = interaction.reactProfilerTimings, rate = interaction.rate, routeName = interaction.routeName, previousInteractionName = interaction.previousInteractionName, isPreviousInteractionAborted = interaction.isPreviousInteractionAborted, abortedByInteractionName = interaction.abortedByInteractionName; // Group segments by name and select the first segment for each name
                    segmentsByName = new Map();
                    _iterator = $7fcf37ca78866e6a$var$_createForOfIteratorHelper(knownSegments);
                    _context3.prev = 9;
                    _loop = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5Cxn4))).mark(function _loop() {
                        var segment, segmentId, name, isRootSegment, segmentProfilerTimings, firstMountTiming, firstMountTime, existingEntry;
                        return (0, (/*@__PURE__*/$parcel$interopDefault($5Cxn4))).wrap(function _loop$(_context) {
                            while(true)switch(_context.prev = _context.next){
                                case 0:
                                    segment = _step.value;
                                    segmentId = (0, $4pcAq.default)(segment.labelStack); // skip if no segmentId
                                    if (segmentId) {
                                        _context.next = 4;
                                        break;
                                    }
                                    return _context.abrupt("return", 0);
                                case 4:
                                    name = segment.labelStack[segment.labelStack.length - 1].name;
                                    isRootSegment = (0, $dfr9R.default)(segment.labelStack);
                                    segmentProfilerTimings = reactProfilerTimings.filter(function(timing) {
                                        var timingSegmentId = (0, $4pcAq.default)(timing.labelStack);
                                        // check if labelStack matches exactly
                                        return timingSegmentId === segmentId;
                                    }).sort(function(a, b) {
                                        return a.startTime - b.startTime;
                                    });
                                    firstMountTiming = segmentProfilerTimings.find(function(timing) {
                                        return timing.type === 'mount';
                                    });
                                    if (firstMountTiming) {
                                        _context.next = 10;
                                        break;
                                    }
                                    return _context.abrupt("return", 0);
                                case 10:
                                    firstMountTime = isRootSegment ? interaction.start : firstMountTiming.startTime; // Check if we already have a segment with this name
                                    existingEntry = segmentsByName.get(name);
                                    if (!existingEntry || firstMountTime < existingEntry.firstMountTime) // Either first time seeing this name, or this segment mounted earlier
                                    segmentsByName.set(name, {
                                        segment: segment,
                                        firstMountTime: firstMountTime
                                    });
                                case 13:
                                case "end":
                                    return _context.stop();
                            }
                        }, _loop);
                    });
                    _iterator.s();
                case 12:
                    if ((_step = _iterator.n()).done) {
                        _context3.next = 19;
                        break;
                    }
                    return _context3.delegateYield(_loop(), "t0", 14);
                case 14:
                    _ret = _context3.t0;
                    if (!(_ret === 0)) {
                        _context3.next = 17;
                        break;
                    }
                    return _context3.abrupt("continue", 17);
                case 17:
                    _context3.next = 12;
                    break;
                case 19:
                    _context3.next = 24;
                    break;
                case 21:
                    _context3.prev = 21;
                    _context3.t1 = _context3["catch"](9);
                    _iterator.e(_context3.t1);
                case 24:
                    _context3.prev = 24;
                    _iterator.f();
                    return _context3.finish(24);
                case 27:
                    // Create payloads only for the selected segments (first one per name)
                    payloads = [];
                    _iterator2 = $7fcf37ca78866e6a$var$_createForOfIteratorHelper(segmentsByName.values());
                    _context3.prev = 29;
                    _loop2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5Cxn4))).mark(function _loop2() {
                        var _window$location;
                        var segment, segmentId, name, isRootSegment, segmentProfilerTimings, firstMountTiming, lastTiming, startTime, endTime, ttai, _getSegmentStatus, status, segmentAbortReason, properties, payload;
                        return (0, (/*@__PURE__*/$parcel$interopDefault($5Cxn4))).wrap(function _loop2$(_context2) {
                            while(true)switch(_context2.prev = _context2.next){
                                case 0:
                                    segment = _step2.value.segment;
                                    segmentId = (0, $4pcAq.default)(segment.labelStack);
                                    name = segment.labelStack[segment.labelStack.length - 1].name;
                                    isRootSegment = (0, $dfr9R.default)(segment.labelStack);
                                    segmentProfilerTimings = reactProfilerTimings.filter(function(timing) {
                                        var timingSegmentId = (0, $4pcAq.default)(timing.labelStack);
                                        // check if labelStack matches exactly
                                        return timingSegmentId === segmentId;
                                    }).sort(function(a, b) {
                                        return a.startTime - b.startTime;
                                    });
                                    firstMountTiming = segmentProfilerTimings.find(function(timing) {
                                        return timing.type === 'mount';
                                    }); // We already checked this exists in the grouping phase
                                    if (firstMountTiming) {
                                        _context2.next = 8;
                                        break;
                                    }
                                    return _context2.abrupt("return", 0);
                                case 8:
                                    lastTiming = segmentProfilerTimings[segmentProfilerTimings.length - 1];
                                    startTime = isRootSegment ? interaction.start : firstMountTiming.startTime;
                                    endTime = lastTiming.commitTime;
                                    ttai = Math.round(endTime - startTime);
                                    _getSegmentStatus = (0, $bexUI.default)(interaction, segment), status = _getSegmentStatus.status, segmentAbortReason = _getSegmentStatus.abortReason;
                                    if (!(status !== 'SUCCEEDED')) {
                                        _context2.next = 15;
                                        break;
                                    }
                                    return _context2.abrupt("return", 0);
                                case 15:
                                    properties = $7fcf37ca78866e6a$var$_objectSpread({
                                        // Basic metadata
                                        'event:hostname': ((_window$location = window.location) === null || _window$location === void 0 ? void 0 : _window$location.hostname) || 'unknown',
                                        'event:product': config.product,
                                        'event:schema': '1.0.0',
                                        'event:region': config.region || 'unknown',
                                        'event:source': {
                                            name: 'react-ufo/web',
                                            version: (0, $gzPfK.LATEST_REACT_UFO_PAYLOAD_VERSION)
                                        },
                                        'experience:key': 'custom.ufo.critical-metrics',
                                        'experience:name': name,
                                        // Browser metadata (compact nested format)
                                        browser: browserMetadata.browser,
                                        device: browserMetadata.device,
                                        network: browserMetadata.network,
                                        time: browserMetadata.time,
                                        metrics: {
                                            ttai: ttai,
                                            tti: ttai
                                        },
                                        interactionId: interactionId,
                                        type: 'page_segment_load',
                                        rate: rate,
                                        routeName: routeName !== null && routeName !== void 0 ? routeName : undefined,
                                        // Performance timings
                                        start: Math.round(startTime),
                                        end: Math.round(endTime),
                                        // Status and outcome
                                        status: status,
                                        abortReason: segmentAbortReason,
                                        previousInteractionName: previousInteractionName,
                                        isPreviousInteractionAborted: isPreviousInteractionAborted,
                                        abortedByInteractionName: abortedByInteractionName,
                                        pageVisibilityAtTTAI: pageVisibilityAtTTAI,
                                        // Basic error count (not detailed error count)
                                        errorCount: interaction.errors.length
                                    }, Object.keys(cohortingCustomData || {}).length > 0 && {
                                        cohortingCustomData: cohortingCustomData
                                    });
                                    payload = {
                                        actionSubject: 'experience',
                                        action: 'measured',
                                        eventType: 'operational',
                                        source: 'measured',
                                        tags: [
                                            'observability'
                                        ],
                                        attributes: {
                                            properties: properties
                                        }
                                    };
                                    payloads.push(payload);
                                case 18:
                                case "end":
                                    return _context2.stop();
                            }
                        }, _loop2);
                    });
                    _iterator2.s();
                case 32:
                    if ((_step2 = _iterator2.n()).done) {
                        _context3.next = 39;
                        break;
                    }
                    return _context3.delegateYield(_loop2(), "t2", 34);
                case 34:
                    _ret2 = _context3.t2;
                    if (!(_ret2 === 0)) {
                        _context3.next = 37;
                        break;
                    }
                    return _context3.abrupt("continue", 37);
                case 37:
                    _context3.next = 32;
                    break;
                case 39:
                    _context3.next = 44;
                    break;
                case 41:
                    _context3.prev = 41;
                    _context3.t3 = _context3["catch"](29);
                    _iterator2.e(_context3.t3);
                case 44:
                    _context3.prev = 44;
                    _iterator2.f();
                    return _context3.finish(44);
                case 47:
                    return _context3.abrupt("return", payloads);
                case 48:
                case "end":
                    return _context3.stop();
            }
        }, _callee, null, [
            [
                9,
                21,
                24,
                27
            ],
            [
                29,
                41,
                44,
                47
            ]
        ]);
    }));
    return $7fcf37ca78866e6a$var$_createSegmentMetricsPayloads.apply(this, arguments);
}

});
parcelRegister("dfr9R", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $9a51be12b0ca781c$export$2e2bcd8739ae039; });
function $9a51be12b0ca781c$export$2e2bcd8739ae039(labelStack) {
    return labelStack.length === 1;
}

});

parcelRegister("4pcAq", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $335342a93989537a$export$2e2bcd8739ae039; });
function $335342a93989537a$export$2e2bcd8739ae039(labelStack) {
    for(var i = labelStack.length - 1; i >= 0; i--){
        var label = labelStack[i];
        if ('segmentId' in label) return label.segmentId;
    }
    return undefined;
}

});

parcelRegister("bexUI", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $82db4f0f53c2183c$export$2e2bcd8739ae039; });

var $g5BNF = parcelRequire("g5BNF");

var $4pcAq = parcelRequire("4pcAq");

var $9Gs1b = parcelRequire("9Gs1b");

var $lBGs4 = parcelRequire("lBGs4");
function $82db4f0f53c2183c$var$_createForOfIteratorHelper(r, e) {
    var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (!t) {
        if (Array.isArray(r) || (t = $82db4f0f53c2183c$var$_unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) {
            t && (r = t);
            var _n = 0, F = function F() {};
            return {
                s: F,
                n: function n() {
                    return _n >= r.length ? {
                        done: !0
                    } : {
                        done: !1,
                        value: r[_n++]
                    };
                },
                e: function e(r) {
                    throw r;
                },
                f: F
            };
        }
        throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }
    var o, a = !0, u = !1;
    return {
        s: function s() {
            t = t.call(r);
        },
        n: function n() {
            var r = t.next();
            return a = r.done, r;
        },
        e: function e(r) {
            u = !0, o = r;
        },
        f: function f() {
            try {
                a || null == t.return || t.return();
            } finally{
                if (u) throw o;
            }
        }
    };
}
function $82db4f0f53c2183c$var$_unsupportedIterableToArray(r, a) {
    if (r) {
        if ("string" == typeof r) return $82db4f0f53c2183c$var$_arrayLikeToArray(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? $82db4f0f53c2183c$var$_arrayLikeToArray(r, a) : void 0;
    }
}
function $82db4f0f53c2183c$var$_arrayLikeToArray(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}
function $82db4f0f53c2183c$export$2e2bcd8739ae039(interaction, segment) {
    var segmentId = (0, $4pcAq.default)(segment.labelStack);
    // Get the root interaction status info
    var rootInteractionStatus = (0, $g5BNF.default)(interaction);
    var rootStatus = rootInteractionStatus.originalInteractionStatus;
    var rootAbortReason = interaction.abortReason;
    var isInteractionsAbortedByNewInteraction = rootStatus === 'ABORTED' && rootAbortReason === 'new_interaction';
    var isInteractionsAbortedByTransition = rootStatus === 'ABORTED' && rootAbortReason === 'transition';
    var status = 'SUCCEEDED';
    var abortReason;
    // Check if this specific segment has failed
    if (segmentId && (0, $9Gs1b.default)(interaction.errors, segmentId)) status = 'FAILED';
    else if (isInteractionsAbortedByNewInteraction) {
        status = 'ABORTED';
        abortReason = 'new_interaction';
    } else if (isInteractionsAbortedByTransition) {
        status = 'ABORTED';
        abortReason = 'transition';
    } else if (segmentId) {
        // Check for active holds that are under this segment
        var _iterator = $82db4f0f53c2183c$var$_createForOfIteratorHelper(interaction.holdActive.values()), _step;
        try {
            for(_iterator.s(); !(_step = _iterator.n()).done;){
                var activeHold = _step.value;
                if ((0, $lBGs4.default)(activeHold.labelStack, segmentId)) {
                    status = 'ABORTED';
                    abortReason = 'timeout';
                    break;
                }
            }
        } catch (err) {
            _iterator.e(err);
        } finally{
            _iterator.f();
        }
    }
    return {
        status: status,
        abortReason: abortReason
    };
}

});
parcelRegister("9Gs1b", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $70cdc51a63327a48$export$2e2bcd8739ae039; });

var $4pcAq = parcelRequire("4pcAq");
function $70cdc51a63327a48$export$2e2bcd8739ae039(errors, segmentId) {
    return errors.some(function(error) {
        if (!error.labelStack) return false;
        var errorSegmentId = (0, $4pcAq.default)(error.labelStack);
        return errorSegmentId === segmentId;
    });
}

});

parcelRegister("lBGs4", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $fbadfbb8a654322c$export$2e2bcd8739ae039; });
function $fbadfbb8a654322c$export$2e2bcd8739ae039(labelStack, segmentId) {
    return labelStack.some(function(label) {
        return 'segmentId' in label && label.segmentId === segmentId;
    });
}

});




parcelRegister("eNXJU", function(module, exports) {
$parcel$export(module.exports, "addPerformanceMeasures", function () { return $ac73fb4e9ee188c8$export$aae9bceb5496a29f; });
var $ac73fb4e9ee188c8$export$aae9bceb5496a29f = function addPerformanceMeasures(start, measures) {
    try {
        measures.sort(function(a, b) {
            return b.revision.localeCompare(a.revision);
        }).slice(0, 2).forEach(function(entry) {
            var _entry$vcDetails;
            if (((_entry$vcDetails = entry.vcDetails) === null || _entry$vcDetails === void 0 || (_entry$vcDetails = _entry$vcDetails['90']) === null || _entry$vcDetails === void 0 ? void 0 : _entry$vcDetails.t) !== undefined) {
                var _entry$vcDetails2;
                performance.mark("VC90 (".concat(entry.revision, ")"), {
                    startTime: start + ((_entry$vcDetails2 = entry.vcDetails) === null || _entry$vcDetails2 === void 0 || (_entry$vcDetails2 = _entry$vcDetails2['90']) === null || _entry$vcDetails2 === void 0 ? void 0 : _entry$vcDetails2.t),
                    detail: {
                        devtools: {
                            dataType: 'marker'
                        }
                    }
                });
            }
        });
        measures.forEach(function(entry) {
            var _entry$vcDetails3;
            if (!entry || !entry.vcDetails) return;
            var VCParts = Object.keys(entry.vcDetails);
            performance.measure("VC90 (".concat(entry.revision, ")"), {
                start: start,
                duration: (_entry$vcDetails3 = entry.vcDetails) === null || _entry$vcDetails3 === void 0 || (_entry$vcDetails3 = _entry$vcDetails3['90']) === null || _entry$vcDetails3 === void 0 ? void 0 : _entry$vcDetails3.t,
                detail: {
                    devtools: {
                        track: "main metrics",
                        trackGroup: "\uD83D\uDEF8 reactUFO metrics",
                        color: 'tertiary'
                    }
                }
            });
            VCParts.forEach(function(key) {
                var _entry$vcDetails4;
                var duration = (_entry$vcDetails4 = entry.vcDetails) === null || _entry$vcDetails4 === void 0 ? void 0 : _entry$vcDetails4[key].t;
                if (typeof duration !== 'number') return;
                performance.measure("VC".concat(key), {
                    start: start,
                    duration: duration,
                    detail: {
                        devtools: {
                            track: "VC ".concat(entry.revision),
                            trackGroup: "\uD83D\uDEF8 reactUFO metrics",
                            color: key === '90' ? 'tertiary' : 'primary-light'
                        }
                    }
                });
            });
        });
    } catch (_unused) {}
};

});

parcelRegister("lnabs", function(module, exports) {
$parcel$export(module.exports, "getBatteryInfoToLegacyFormat", function () { return $f8f3a540710fd86a$export$42f40d22522b34d7; });

var $cn8ql = parcelRequire("cn8ql");

var $5Cxn4 = parcelRequire("5Cxn4");
function $f8f3a540710fd86a$export$2e2bcd8739ae039() {
    return $f8f3a540710fd86a$var$_getBatteryInfo.apply(this, arguments);
}
// Helper function to get battery info in legacy colon format for backward compatibility
function $f8f3a540710fd86a$var$_getBatteryInfo() {
    $f8f3a540710fd86a$var$_getBatteryInfo = (0, $cn8ql.default)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5Cxn4))).mark(function _callee() {
        var battery;
        return (0, (/*@__PURE__*/$parcel$interopDefault($5Cxn4))).wrap(function _callee$(_context) {
            while(true)switch(_context.prev = _context.next){
                case 0:
                    if (!(typeof navigator === 'undefined')) {
                        _context.next = 2;
                        break;
                    }
                    return _context.abrupt("return", {});
                case 2:
                    _context.prev = 2;
                    if (!('getBattery' in navigator)) {
                        _context.next = 9;
                        break;
                    }
                    _context.next = 6;
                    return navigator.getBattery();
                case 6:
                    battery = _context.sent;
                    if (!(battery && typeof battery.level === 'number' && typeof battery.charging === 'boolean')) {
                        _context.next = 9;
                        break;
                    }
                    return _context.abrupt("return", {
                        level: Math.round(battery.level * 100) / 100,
                        // Round to 0.01
                        charging: battery.charging
                    });
                case 9:
                    _context.next = 13;
                    break;
                case 11:
                    _context.prev = 11;
                    _context.t0 = _context["catch"](2);
                case 13:
                    return _context.abrupt("return", {});
                case 14:
                case "end":
                    return _context.stop();
            }
        }, _callee, null, [
            [
                2,
                11
            ]
        ]);
    }));
    return $f8f3a540710fd86a$var$_getBatteryInfo.apply(this, arguments);
}
function $f8f3a540710fd86a$export$42f40d22522b34d7() {
    return $f8f3a540710fd86a$var$_getBatteryInfoToLegacyFormat.apply(this, arguments);
}
function $f8f3a540710fd86a$var$_getBatteryInfoToLegacyFormat() {
    $f8f3a540710fd86a$var$_getBatteryInfoToLegacyFormat = (0, $cn8ql.default)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5Cxn4))).mark(function _callee2() {
        var battery, legacyFormat;
        return (0, (/*@__PURE__*/$parcel$interopDefault($5Cxn4))).wrap(function _callee2$(_context2) {
            while(true)switch(_context2.prev = _context2.next){
                case 0:
                    _context2.next = 2;
                    return $f8f3a540710fd86a$export$2e2bcd8739ae039();
                case 2:
                    battery = _context2.sent;
                    legacyFormat = {};
                    if (battery.level !== undefined) legacyFormat['event:battery:level'] = battery.level;
                    if (battery.charging !== undefined) legacyFormat['event:battery:charging'] = battery.charging;
                    return _context2.abrupt("return", legacyFormat);
                case 7:
                case "end":
                    return _context2.stop();
            }
        }, _callee2);
    }));
    return $f8f3a540710fd86a$var$_getBatteryInfoToLegacyFormat.apply(this, arguments);
}

});

parcelRegister("lINhO", function(module, exports) {
$parcel$export(module.exports, "trimVcDebugData", function () { return $fd03f0422d9b4550$export$94b3eb4abbe372bc; });

var $2qaZZ = parcelRequire("2qaZZ");
function $fd03f0422d9b4550$var$_createForOfIteratorHelper(r, e) {
    var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (!t) {
        if (Array.isArray(r) || (t = $fd03f0422d9b4550$var$_unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) {
            t && (r = t);
            var _n = 0, F = function F() {};
            return {
                s: F,
                n: function n() {
                    return _n >= r.length ? {
                        done: !0
                    } : {
                        done: !1,
                        value: r[_n++]
                    };
                },
                e: function e(r) {
                    throw r;
                },
                f: F
            };
        }
        throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }
    var o, a = !0, u = !1;
    return {
        s: function s() {
            t = t.call(r);
        },
        n: function n() {
            var r = t.next();
            return a = r.done, r;
        },
        e: function e(r) {
            u = !0, o = r;
        },
        f: function f() {
            try {
                a || null == t.return || t.return();
            } finally{
                if (u) throw o;
            }
        }
    };
}
function $fd03f0422d9b4550$var$_unsupportedIterableToArray(r, a) {
    if (r) {
        if ("string" == typeof r) return $fd03f0422d9b4550$var$_arrayLikeToArray(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? $fd03f0422d9b4550$var$_arrayLikeToArray(r, a) : void 0;
    }
}
function $fd03f0422d9b4550$var$_arrayLikeToArray(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}
var $fd03f0422d9b4550$export$f2dd9169431963eb = 'ufo:vc:rev.vcDetails.e';
/** VC viewport checkpoints to trim; we keep `e` arrays for the rest. */ var $fd03f0422d9b4550$var$VC_CHECKPOINTS_TO_TRIM = [
    '25',
    '50',
    '75'
];
function $fd03f0422d9b4550$export$94b3eb4abbe372bc(/** Properties object to trim VC debug data from. */ properties, /** Current payload size in KB (e.g. from getPayloadSize(properties)). */ currentPayloadSizeKb, /** Maximum allowed payload size in KB. Trim runs only when currentPayloadSizeKb > maxPayloadSizeKb. */ maxPayloadSizeKb, /** Whether VC revision trim is enabled (e.g. from feature flag). */ isEnabled) {
    var isTrimmed = false;
    var isPayloadSizeExceeded = currentPayloadSizeKb > maxPayloadSizeKb;
    if (!isEnabled || !isPayloadSizeExceeded) return;
    var vcRev = properties['ufo:vc:rev'];
    if (!Array.isArray(vcRev) || vcRev.length === 0) return;
    var _iterator = $fd03f0422d9b4550$var$_createForOfIteratorHelper(vcRev), _step;
    try {
        for(_iterator.s(); !(_step = _iterator.n()).done;){
            var rev = _step.value;
            for(var _i = 0, _Object$entries = Object.entries((_rev$vcDetails = rev.vcDetails) !== null && _rev$vcDetails !== void 0 ? _rev$vcDetails : {}); _i < _Object$entries.length; _i++){
                var _rev$vcDetails;
                var _Object$entries$_i = (0, $2qaZZ.default)(_Object$entries[_i], 2), key = _Object$entries$_i[0], detail = _Object$entries$_i[1];
                if ($fd03f0422d9b4550$var$VC_CHECKPOINTS_TO_TRIM.includes(key)) {
                    detail.e = [];
                    isTrimmed = true;
                }
            }
        }
    } catch (err) {
        _iterator.e(err);
    } finally{
        _iterator.f();
    }
    if (isTrimmed) {
        properties['event:isTrimmed'] = isTrimmed;
        var trimmedFields = properties['event:trimmedFields'];
        if (!Array.isArray(trimmedFields)) trimmedFields = [];
        trimmedFields.push($fd03f0422d9b4550$export$f2dd9169431963eb);
        properties['event:trimmedFields'] = trimmedFields;
    }
}

});



//# sourceMappingURL=create-payload.90824b57.js.map
